import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../Layout/Layout';
import CollabMeetingRoom from './CollabMeetingRoom';
import api from '../../utils/api';
import { useUser } from '../../contexts/UserContext';
const CollabMeetingDashboard = () => {
    const { user, setUser } = useUser();
    const [meetings, setMeetings] = useState([]);
    const [guestName, setGuestName] = useState('');
    const [guestMeetingTitle, setGuestMeetingTitle] = useState('');
    const [guestLoading, setGuestLoading] = useState(false);
    const [guestError, setGuestError] = useState('');
    const [checkingGuestMeeting, setCheckingGuestMeeting] = useState(true);
    const [roomId, setRoomId] = useState(null);
    const handleGuestJoinSubmit = async (e) => {
        e.preventDefault();
        if (!guestName.trim()) {
            setGuestError("Please enter your name to join the meeting.");
            return;
        }

        setGuestLoading(true);
        setGuestError('');
        try {
            const response = await api.post('/collab-meetings/guest-join', {
                name: guestName.trim(),
                meeting_id: roomId
            });
            if (response.data && response.data.status === 'success') {
                const { token, user: guestUser } = response.data;
                localStorage.setItem('token', token);
                setUser(guestUser);
            }

        } catch (err) {
            setGuestError(err.response?.data?.messages?.error || err.response?.data?.error || "Failed to join the meeting as guest.");
        } finally {
            setGuestLoading(false);
        }

    };
    const [visibleCount, setVisibleCount] = useState(4);
    const [loading, setLoading] = useState(true);
    const [activeMeeting, setActiveMeeting] = useState(null);
    const [meetingCodeInput, setMeetingCodeInput] = useState('');
    const [joiningMeeting, setJoiningMeeting] = useState(false);
    // Dropdown and modal states

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showLaterModal, setShowLaterModal] = useState(false);
    const [showCreateLaterTargetModal, setShowCreateLaterTargetModal] = useState(false);
    const [meetingCreationMode, setMeetingCreationMode] = useState('later'); // 'later' or 'instant'
    const [createLaterShowEmployees, setCreateLaterShowEmployees] = useState(false);
    const [createLaterShowCustomers, setCreateLaterShowCustomers] = useState(false);
    const [createLaterShowExternal, setCreateLaterShowExternal] = useState(false);
    const [createLaterDate, setCreateLaterDate] = useState('');
    const [createLaterTime, setCreateLaterTime] = useState('');
    const [createMeetingTitle, setCreateMeetingTitle] = useState('');
    const [createdMeetingLink, setCreatedMeetingLink] = useState('');
    const [createdMeetingId, setCreatedMeetingId] = useState('');
    const [showCalendarModal, setShowCalendarModal] = useState(false);
    // Custom dialog/popup states

    const [alertPopup, setAlertPopup] = useState({ show: false, message: '', title: 'Notification' });
    const [confirmPopup, setConfirmPopup] = useState({ show: false, message: '', title: 'Confirm', onConfirm: null });
    const [resolutionPopup, setResolutionPopup] = useState({ show: false, escalationId: null, notes: '' });
    const [editMeetingModal, setEditMeetingModal] = useState({
        show: false,
        meetingId: null,
        title: '',
        date: '',
        startTime: '',
        endTime: '',
        errors: {}
    });
    // Calendar scheduling states

    const [spaces, setSpaces] = useState([]);
    const [showScheduleFormModal, setShowScheduleFormModal] = useState(false);
    const [scheduleTitle, setScheduleTitle] = useState('');
    const [scheduleDate, setScheduleDate] = useState('');
    const [scheduleStartTime, setScheduleStartTime] = useState('16:00');
    const [scheduleEndTime, setScheduleEndTime] = useState('17:00');
    const [scheduleType, setScheduleType] = useState('online');
    const [scheduleSpaceId, setScheduleSpaceId] = useState(1);
    const [scheduleDescription, setScheduleDescription] = useState('');
    const [scheduleLocation, setScheduleLocation] = useState('');
    const [scheduleNotification, setScheduleNotification] = useState(30);
    const [scheduleBusy, setScheduleBusy] = useState(true);
    const [scheduleVisibility, setScheduleVisibility] = useState('default');
    const [scheduleGuests, setScheduleGuests] = useState('');
    const [scheduleBuilding, setScheduleBuilding] = useState('');
    const [scheduleFloor, setScheduleFloor] = useState('');
    const [scheduleRoomName, setScheduleRoomName] = useState('Alpha Suite');
    const [scheduleSeatingCapacity, setScheduleSeatingCapacity] = useState('12');
    const [scheduleExternalMeetingUrl, setScheduleExternalMeetingUrl] = useState('');
    const [scheduleMeetingPasscode, setScheduleMeetingPasscode] = useState('');
    const [scheduleRecurring, setScheduleRecurring] = useState('none');
    const [scheduleFormErrors, setScheduleFormErrors] = useState({});
    // Attendance & target visibility states

    const [targetType, setTargetType] = useState(['all_employees']);
    const [allEmployeesList, setAllEmployeesList] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [allCustomersList, setAllCustomersList] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [employeeSearchQuery, setEmployeeSearchQuery] = useState('');
    const [customerSearchQuery, setCustomerSearchQuery] = useState('');
    const [manualEmails, setManualEmails] = useState('');
    // Provider account management states

    const [scheduleAutoSchedule, setScheduleAutoSchedule] = useState(true);
    const [providerAvailability, setProviderAvailability] = useState(null);
    const [providerAccounts, setProviderAccounts] = useState([]);
    const [escalations, setEscalations] = useState([]);
    const [showProviderAdmin, setShowProviderAdmin] = useState(false);
    const [providerFormData, setProviderFormData] = useState({
        provider: 'zoom', account_label: '', email: '', client_id: '', client_secret: '',
        account_id: '', api_key: '', api_secret: '', refresh_token: '',
        max_concurrent: 1, subscription_tier: 'pro', notes: ''
    });
    const [showProviderForm, setShowProviderForm] = useState(false);
    const [editingProviderId, setEditingProviderId] = useState(null);
    const [providerTestResult, setProviderTestResult] = useState(null);
    const dropdownRef = useRef(null);
    const prevActiveMeetingRef = useRef(null);
    const fetchEmployees = async () => {
        try {
            const response = await api.get('/collab-meetings/employees');
            if (response.data && response.data.status === 'success') {
                setAllEmployeesList(response.data.data || []);
            }

        } catch (error) {
            console.error('Error fetching employees:', error);
        }

    };
    const fetchCustomers = async () => {
        try {
            const response = await api.get('/collab-meetings/customers');
            if (response.data && response.data.status === 'success') {
                setAllCustomersList(response.data.data || []);
            }

        } catch (error) {
            console.error('Error fetching customers:', error);
        }

    };
    useEffect(() => {
        if (showScheduleFormModal || showCreateLaterTargetModal) {
            fetchEmployees();
            fetchCustomers();
        }

    }, [showScheduleFormModal, showCreateLaterTargetModal]);
    // Check availability dynamically when date/time or type changes

    useEffect(() => {
        if (!showScheduleFormModal || !scheduleAutoSchedule) return;
        if (scheduleType !== 'hybrid_zoom' && scheduleType !== 'hybrid_google_meet') return;
        const checkAvailability = async () => {
            try {
                const startStr = `${scheduleDate} ${scheduleStartTime}:00`;
                let endStr = '';
                if (!scheduleEndTime) {
                    const startDt = new Date(`${scheduleDate} ${scheduleStartTime}:00`);
                    if (!isNaN(startDt.getTime())) {
                        startDt.setHours(startDt.getHours() + 1);
                        const year = startDt.getFullYear();
                        const month = String(startDt.getMonth() + 1).padStart(2, '0');
                        const day = String(startDt.getDate()).padStart(2, '0');
                        const hours = String(startDt.getHours()).padStart(2, '0');
                        const minutes = String(startDt.getMinutes()).padStart(2, '0');
                        endStr = `${year}-${month}-${day} ${hours}:${minutes}:00`;
                    }
                } else {
                    endStr = `${scheduleDate} ${scheduleEndTime}:00`;
                }
                const provider = scheduleType === 'hybrid_zoom' ? 'zoom' : 'google_meet';
                const response = await api.post('/collab-meetings/provider-availability', {
                    provider,
                    start_time: startStr,
                    end_time: endStr
                });
                if (response.data && response.data.status === 'success') {
                    setProviderAvailability(response.data.data);
                }
            } catch (err) {
                console.error('Failed to check provider availability:', err);
            }
        };
        if (scheduleDate && scheduleStartTime) {
            checkAvailability();
        }
    }, [scheduleDate, scheduleStartTime, scheduleEndTime, scheduleType, scheduleAutoSchedule, showScheduleFormModal]);
    const fetchProviderAccounts = async () => {
        try {
            const response = await api.get('/collab-meetings/provider-accounts');
            if (response.data?.status === 'success') {
                setProviderAccounts(response.data.data);
            }

        } catch (err) {
            console.error('Failed to fetch provider accounts:', err);
        }

    };
    const fetchEscalations = async () => {
        try {
            const response = await api.get('/collab-meetings/escalations');
            if (response.data?.status === 'success') {
                setEscalations(response.data.data);
            }

        } catch (err) {
            console.error('Failed to fetch escalations:', err);
        }

    };
    const handleSaveProviderAccount = async () => {
        try {
            if (editingProviderId) {
                await api.put(`/collab-meetings/provider-accounts/${editingProviderId}`, providerFormData);
            } else {
                await api.post('/collab-meetings/provider-accounts', providerFormData);
            }

            setShowProviderForm(false);
            setEditingProviderId(null);
            fetchProviderAccounts();
        } catch (err) {
            setAlertPopup({
                show: true,
                title: 'Error',
                message: 'Failed to save provider account: ' + (err.response?.data?.messages?.error || err.message)
            });
        }

    };
    const handleDeleteProviderAccount = (id) => {
        setConfirmPopup({
            show: true,
            title: 'Delete Account',
            message: 'Are you sure you want to delete this provider account?',
            onConfirm: async () => {
                try {
                    await api.delete(`/collab-meetings/provider-accounts/${id}`);
                    fetchProviderAccounts();
                } catch (err) {
                    setAlertPopup({
                        show: true,
                        title: 'Error',
                        message: 'Failed to delete account.'
                    });
                }
            }
        });

    };
    const handleTestProviderAccount = async (id) => {
        try {
            const response = await api.post(`/collab-meetings/provider-accounts/${id}/test`);
            if (response.data?.status === 'success') {
                setProviderTestResult(response.data.data);
                setTimeout(() => setProviderTestResult(null), 5000);
            }

        } catch (err) {
            setAlertPopup({
                show: true,
                title: 'Test Failed',
                message: 'Test failed: ' + err.message
            });
        }

    };
    const handleResolveEscalation = (id) => {
        setResolutionPopup({ show: true, escalationId: id, notes: '' });
    };

    const submitEscalationResolution = async () => {
        const { escalationId, notes } = resolutionPopup;
        if (!notes.trim()) {
            setAlertPopup({
                show: true,
                title: 'Validation Error',
                message: 'Please enter resolution notes before submitting.'
            });
            return;
        }

        try {
            await api.post(`/collab-meetings/escalations/${escalationId}/resolve`, { resolution: notes });
            setResolutionPopup({ show: false, escalationId: null, notes: '' });
            fetchEscalations();
        } catch (err) {
            setAlertPopup({
                show: true,
                title: 'Error',
                message: 'Failed to resolve escalation: ' + (err.response?.data?.message || err.message)
            });
        }
    };

    const handleEditMeeting = (e, meeting) => {
        e.stopPropagation();
        
        const isNotEditable = (meeting.status && meeting.status !== 'scheduled') || (new Date(meeting.start_time.replace(/-/g, "/")).getTime() <= Date.now());
        if (isNotEditable) {
            setAlertPopup({
                show: true,
                title: 'Not Editable',
                message: 'This meeting is in progress, completed, or has already started and cannot be edited.'
            });
            return;
        }
        
        const startDt = new Date(meeting.start_time.replace(/-/g, "/"));
        const yr = startDt.getFullYear();
        const mo = String(startDt.getMonth() + 1).padStart(2, '0');
        const dy = String(startDt.getDate()).padStart(2, '0');
        const hr = String(startDt.getHours()).padStart(2, '0');
        const mn = String(startDt.getMinutes()).padStart(2, '0');
        
        const datePart = `${yr}-${mo}-${dy}`;
        const startTimePart = `${hr}:${mn}`;
        
        let endTimePart = '';
        if (meeting.end_time) {
            const endDt = new Date(meeting.end_time.replace(/-/g, "/"));
            const eHr = String(endDt.getHours()).padStart(2, '0');
            const eMn = String(endDt.getMinutes()).padStart(2, '0');
            endTimePart = `${eHr}:${eMn}`;
        }

        setEditMeetingModal({
            show: true,
            meetingId: meeting.id,
            title: meeting.title || '',
            date: datePart,
            startTime: startTimePart,
            endTime: endTimePart,
            errors: {}
        });
    };

    const submitEditMeeting = async () => {
        const errors = {};
        if (!editMeetingModal.title.trim()) {
            errors.title = 'Title is required.';
        }
        if (!editMeetingModal.date) {
            errors.date = 'Date is required.';
        }
        if (!editMeetingModal.startTime) {
            errors.startTime = 'Start time is required.';
        }

        const startDateTimeStr = `${editMeetingModal.date} ${editMeetingModal.startTime}:00`;
        const startTimestamp = new Date(startDateTimeStr.replace(/-/g, "/")).getTime();

        let endDateTimeStr = '';
        if (editMeetingModal.endTime && editMeetingModal.endTime !== '00:00') {
            endDateTimeStr = `${editMeetingModal.date} ${editMeetingModal.endTime}:00`;
            const endTimestamp = new Date(endDateTimeStr.replace(/-/g, "/")).getTime();
            if (endTimestamp <= startTimestamp) {
                errors.time = 'End time must be after the start time.';
            }
        }

        if (Object.keys(errors).length > 0) {
            setEditMeetingModal(prev => ({ ...prev, errors }));
            return;
        }

        try {
            await api.put(`/collab-meetings/meeting/${editMeetingModal.meetingId}`, {
                title: editMeetingModal.title,
                start_time: startDateTimeStr,
                end_time: endDateTimeStr || null
            });

            setEditMeetingModal({
                show: false,
                meetingId: null,
                title: '',
                date: '',
                startTime: '',
                endTime: '',
                errors: {}
            });

            setAlertPopup({
                show: true,
                title: 'Success',
                message: 'Meeting details successfully updated.'
            });

            fetchMeetings();
        } catch (err) {
            console.error('Failed to update meeting details:', err);
            setAlertPopup({
                show: true,
                title: 'Error',
                message: 'Failed to update meeting details: ' + (err.response?.data?.message || err.message)
            });
        }
    };
    useEffect(() => {
        if (showProviderAdmin) {
            fetchProviderAccounts();
            fetchEscalations();
        }

    }, [showProviderAdmin]);
    // Fetch rooms dynamically on load

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const rId = params.get('room');
        setRoomId(rId);
        if (!user) {
            const token = localStorage.getItem('token');
            if (token) {
                // User profile is still loading from UserProvider. Wait for it.

                return;
            }

            if (!rId) {
                // No user, no token and no room => redirect to login

                window.location.href = '/';
                return;
            }

            // Guest mode: fetch meeting info publicly

            const checkMeeting = async () => {
                try {
                    const response = await api.get(`/collab-meetings/guest-meeting/${rId}`);
                    if (response.data && response.data.status === 'success') {
                        setGuestMeetingTitle(response.data.data.title);
                    } else {
                        setGuestError("Meeting not found or already ended.");
                    }

                } catch (err) {
                    setGuestError("Meeting not found or already ended.");
                } finally {
                    setCheckingGuestMeeting(false);
                }

            };
            checkMeeting();
            setLoading(false);
            return;
        }

        // Authenticated user mode

        fetchMeetings();
        fetchSpaces();
        if (rId) {
            setMeetingCodeInput(rId);
            
            // Auto-join meeting if room ID is present
            const autoJoin = async () => {
                setJoiningMeeting(true);
                try {
                    let cleanId = rId.replace(/[^0-9]/g, '');
                    if (!cleanId) return;
                    
                    const response = await api.get(`/collab-meetings/meeting/${cleanId}`);
                    if (response.data && response.data.status === 'success') {
                        const meeting = response.data.data;
                        setActiveMeeting({ id: meeting.id, name: meeting.title });
                    }
                } catch (error) {
                    console.error("Auto-join failed:", error);
                } finally {
                    setJoiningMeeting(false);
                }
            };
            autoJoin();
        }

    }, [user]);
    // Sync activeMeeting state with browser URL search parameters for refresh stability

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const currentRoomId = params.get('room');
        if (activeMeeting) {
            if (currentRoomId !== String(activeMeeting.id)) {
                const newUrl = `${window.location.pathname}?room=${activeMeeting.id}`;
                window.history.pushState({ room: activeMeeting.id }, '', newUrl);
            }

        } else {
            if (currentRoomId && prevActiveMeetingRef.current) {
                window.history.pushState({}, '', window.location.pathname);
            }

        }

        prevActiveMeetingRef.current = activeMeeting;
    }, [activeMeeting]);
    // Close dropdown on outside click

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }

        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const fetchSpaces = async () => {
        try {
            const response = await api.get('/collab-meetings/spaces');
            if (response.data && response.data.status === 'success') {
                setSpaces(response.data.data || []);
            }

        } catch (error) {
            console.error('Error fetching collab spaces:', error);
        }

    };
    const fetchMeetings = async () => {
        setLoading(true);
        try {
            const response = await api.get('/collab-meetings/meetings');
            if (response.data && response.data.status === 'success') {
                setMeetings(response.data.data || []);
            }

        } catch (error) {
            console.error('Error fetching collab meetings:', error);
        } finally {
            setLoading(false);
        }

    };
    const handleDeleteMeeting = async (e, meetingId) => {
        e.stopPropagation();
        setConfirmPopup({
            show: true,
            title: "Delete Meeting Room",
            message: "Are you sure you want to delete this meeting room for all users?",
            onConfirm: async () => {
                try {
                    const response = await api.delete(`/collab-meetings/meeting/${meetingId}`);
                    if (response.data && response.data.status === 'success') {
                        fetchMeetings();
                    }

                } catch (error) {
                    console.error('Failed to delete meeting:', error);
                    setAlertPopup({
                        show: true,
                        title: 'Error',
                        message: error.response?.data?.messages?.error || 'Failed to delete meeting room.'
                    });
                }

            }

        });
    };
    // Google Meet style: Create a meeting for later

    const handleCreateLaterClick = () => {
        setDropdownOpen(false);
        setMeetingCreationMode('later');
        setCreateLaterShowEmployees(false);
        setCreateLaterShowCustomers(false);
        setCreateLaterShowExternal(false);
        setCreateLaterDate(new Date().toISOString().split('T')[0]);
        setCreateLaterTime('16:00');
        setCreateMeetingTitle('');
        setSelectedEmployees([]);
        setSelectedCustomers([]);
        setEmployeeSearchQuery('');
        setCustomerSearchQuery('');
        setShowCreateLaterTargetModal(true);
    };

    const handleStartInstantClick = () => {
        setDropdownOpen(false);
        setMeetingCreationMode('instant');
        setCreateLaterShowEmployees(false);
        setCreateLaterShowCustomers(false);
        setCreateLaterShowExternal(false);
        setCreateMeetingTitle('');
        setSelectedEmployees([]);
        setSelectedCustomers([]);
        setEmployeeSearchQuery('');
        setCustomerSearchQuery('');
        setShowCreateLaterTargetModal(true);
    };

    const handleTargetSubmit = async () => {
        if (!createLaterShowEmployees && !createLaterShowCustomers) {
            setAlertPopup({ show: true, title: 'Error', message: 'Please check at least Employees or Customers.' });
            return;
        }
        if (createLaterShowEmployees && selectedEmployees.length === 0) {
            setAlertPopup({ show: true, title: 'Error', message: 'Please select at least one employee.' });
            return;
        }

        if (meetingCreationMode === 'later') {
            if (!createLaterDate) {
                setAlertPopup({ show: true, title: 'Error', message: 'Please select a date for the meeting.' });
                return;
            }
            if (!createLaterTime) {
                setAlertPopup({ show: true, title: 'Error', message: 'Please select a time for the meeting.' });
                return;
            }
        }

        setShowCreateLaterTargetModal(false);
        try {
            let titleInput = createMeetingTitle.trim();
            if (!titleInput) {
                const randomSuffix = Math.floor(1000 + Math.random() * 9000);
                titleInput = meetingCreationMode === 'instant' 
                    ? `Quick Sync Room - ${Math.floor(100 + Math.random() * 900)}` 
                    : `Collaboration Room - ${randomSuffix}`;
            }
            
            const payload = {
                title: titleInput,
                space_id: 1,
                meeting_type: 'online'
            };

            if (meetingCreationMode === 'later') {
                payload.start_time = `${createLaterDate} ${createLaterTime}:00`;
                const startDt = new Date(payload.start_time.replace(/-/g, "/"));
                if (!isNaN(startDt.getTime())) {
                    startDt.setHours(startDt.getHours() + 1);
                    const year = startDt.getFullYear();
                    const month = String(startDt.getMonth() + 1).padStart(2, '0');
                    const day = String(startDt.getDate()).padStart(2, '0');
                    const hours = String(startDt.getHours()).padStart(2, '0');
                    const minutes = String(startDt.getMinutes()).padStart(2, '0');
                    payload.end_time = `${year}-${month}-${day} ${hours}:${minutes}:00`;
                }
            }
            
            let targetTypes = [];
            let selEmployees = [];
            
            if (createLaterShowEmployees && selectedEmployees.length > 0) {
                targetTypes.push('selective_employees');
                selEmployees = [...selEmployees, ...selectedEmployees];
            }
            if (createLaterShowCustomers) {
                targetTypes.push('customers');
            }
            
            if (targetTypes.length > 0) {
                payload.target_type = targetTypes.join(',');
            }
            if (selEmployees.length > 0) {
                payload.selected_employees = selEmployees;
            }

            const response = await api.post('/collab-meetings/schedule', payload);
            if (response.data && response.data.status === 'success') {
                const meetingId = response.data.meeting_id;
                
                if (meetingCreationMode === 'instant') {
                    setActiveMeeting({ id: meetingId, name: titleInput });
                } else {
                    setCreatedMeetingId(meetingId);
                    setCreatedMeetingLink(`${window.location.origin}/meetings?room=${meetingId}`);
                    setShowLaterModal(true);
                }
            }

        } catch (error) {
            setAlertPopup({
                show: true,
                title: 'Error',
                message: meetingCreationMode === 'instant' ? 'Failed to start instant meeting.' : 'Failed to schedule meeting room.'
            });
            console.error(error);
        }

    };
    const handleConfirmLater = () => {
        setShowLaterModal(false);
        fetchMeetings();
    };
    const handleCancelLater = async () => {
        setShowLaterModal(false);
        if (createdMeetingId) {
            try {
                await api.delete(`/collab-meetings/meeting/${createdMeetingId}`);
            } catch (error) {
                console.error('Failed to delete canceled meeting:', error);
            }

        }

    };
    // Google Meet style: Start an instant meeting (Logic moved to handleTargetSubmit, keeping placeholder for reference or future use)

    const handleStartInstant = handleStartInstantClick;
    // Google Meet style: Schedule calendar

    const handleScheduleCalendar = () => {
        setDropdownOpen(false);
        // Initialize form fields with sensible defaults

        setScheduleTitle('');
        setScheduleDate(new Date().toISOString().split('T')[0]);
        setScheduleStartTime('16:00');
        setScheduleEndTime('17:00');
        setScheduleType('online');
        setScheduleSpaceId(spaces[0]?.id || 1);
        setScheduleDescription('');
        setScheduleLocation('');
        setScheduleNotification(30);
        setScheduleBusy(true);
        setScheduleVisibility('default');
        setScheduleGuests('');
        setTargetType(['all_employees']);
        setSelectedEmployees([]);
        setSelectedCustomers([]);
        setEmployeeSearchQuery('');
        setCustomerSearchQuery('');
        setManualEmails('');
        setShowScheduleFormModal(true);
    };
    const handleSaveScheduledMeeting = async (e) => {
        e.preventDefault();
        setScheduleFormErrors({});
        const errors = {};
        if (!scheduleTitle.trim()) {
            errors.title = 'Title is required.';
        } else if (scheduleTitle.trim().length < 3) {
            errors.title = 'Title must be at least 3 characters in length.';
        }

        if (!scheduleDate) {
            errors.date = 'Date is required.';
        }

        if (!scheduleStartTime) {
            errors.start_time = 'Start time is required.';
        }

        if (scheduleType === 'physical') {
            if (!scheduleBuilding.trim()) errors.building = 'Building is required for physical meetings.';
            if (!scheduleFloor.trim()) errors.floor = 'Floor is required for physical meetings.';
            if (!scheduleRoomName.trim()) errors.room_name = 'Room name is required for physical meetings.';
            if (!scheduleSeatingCapacity || parseInt(scheduleSeatingCapacity) <= 0) {
                errors.seating_capacity = 'Seating capacity must be greater than 0.';
            }

        } else if (scheduleType === 'hybrid_zoom' || scheduleType === 'hybrid_google_meet') {
            if (!scheduleAutoSchedule) {
                const url = scheduleExternalMeetingUrl.trim();
                if (!url) {
                    errors.external_meeting_url = 'External meeting link is required.';
                } else {
                    const isValidUrl = /^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(url);
                    if (!isValidUrl) {
                        errors.external_meeting_url = 'Please enter a valid URL (starting with http/https).';
                    } else if (scheduleType === 'hybrid_zoom' && !url.toLowerCase().includes('zoom.us')) {
                        errors.external_meeting_url = 'Zoom link must contain "zoom.us".';
                    } else if (scheduleType === 'hybrid_google_meet' && !url.toLowerCase().includes('google.com')) {
                        errors.external_meeting_url = 'Google Meet link must contain "google.com".';
                    }
                }
            }
        }

        const startDateTimeTest = `${scheduleDate} ${scheduleStartTime}:00`;
        const startTimestamp = new Date(startDateTimeTest).getTime();
        let endDateTime = '';
        if (scheduleEndTime && scheduleEndTime !== '00:00') {
            const endDateTimeTest = `${scheduleDate} ${scheduleEndTime}:00`;
            const endTimestamp = new Date(endDateTimeTest).getTime();
            if (isNaN(startTimestamp) || isNaN(endTimestamp)) {
                errors.time = 'Please select a valid date and time.';
            } else if (endTimestamp <= startTimestamp) {
                errors.time = 'End time must be after the start time.';
            }
            endDateTime = endDateTimeTest;
        } else {
            if (isNaN(startTimestamp)) {
                errors.time = 'Please select a valid date and time.';
            } else {
                const startDt = new Date(startDateTimeTest);
                startDt.setHours(startDt.getHours() + 1);
                const year = startDt.getFullYear();
                const month = String(startDt.getMonth() + 1).padStart(2, '0');
                const day = String(startDt.getDate()).padStart(2, '0');
                const hours = String(startDt.getHours()).padStart(2, '0');
                const minutes = String(startDt.getMinutes()).padStart(2, '0');
                endDateTime = `${year}-${month}-${day} ${hours}:${minutes}:00`;
            }
        }

        if (targetType.includes('selective_employees') && selectedEmployees.length === 0) {
            errors.selective_employees = 'Please select at least one employee.';
        }

        if (targetType.includes('manual_emails')) {
            if (!manualEmails.trim()) {
                errors.manual_emails = 'Please add at least one guest email.';
            } else {
                const emails = manualEmails.split(',').map(e => e.trim()).filter(e => e);
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalidEmails = emails.filter(e => !emailRegex.test(e));
                if (invalidEmails.length > 0) {
                    errors.manual_emails = `Invalid email address(es): ${invalidEmails.join(', ')}`;
                }
            }
        }

        if (Object.keys(errors).length > 0) {
            setScheduleFormErrors(errors);
            return;
        }

        try {
            const payload = {
                title: scheduleTitle,
                space_id: scheduleSpaceId,
                meeting_type: scheduleType,
                start_time: startDateTimeTest,
                end_time: endDateTime,
                target_type: targetType.join(','),
                building: scheduleBuilding,
                floor: scheduleFloor,
                room_name: scheduleRoomName,
                seating_capacity: parseInt(scheduleSeatingCapacity) || 0,
                external_meeting_url: scheduleExternalMeetingUrl,
                meeting_passcode: scheduleMeetingPasscode,
                recurring: scheduleRecurring,
                show_as: scheduleBusy ? 'busy' : 'free',
                visibility: scheduleVisibility,
                auto_schedule: scheduleAutoSchedule
            };
            
            payload.selected_employees = [];
            if (targetType.includes('selective_employees')) {
                payload.selected_employees = [...payload.selected_employees, ...selectedEmployees];
            }

            if (targetType.includes('manual_emails')) {
                payload.manual_emails = manualEmails.split(',').map(e => e.trim()).filter(e => e);
            }

            const response = await api.post('/collab-meetings/schedule', payload);
            if (response.data && response.data.status === 'success') {
                setShowScheduleFormModal(false);
                setShowCalendarModal(true);
                fetchMeetings();
                
                if (response.data.provider_scheduled === false) {
                    setAlertPopup({
                        show: true,
                        title: 'Integration Warning',
                        message: `Meeting scheduled successfully, but the external provider API integration failed.\n\nError: ${response.data.provider_error || 'Zoom API returned HTTP 400'}\n\nPlease click 'Join Room' from the dashboard to provide a manual meeting URL or switch to the eNova Online Room.`
                    });
                }
            }

        } catch (error) {
            const status = error.response?.status;
            const errorData = error.response?.data;
            if (status === 400 && errorData?.messages) {
                setScheduleFormErrors(errorData.messages);
                return;
            }
            const message = errorData?.message || 'Failed to schedule meeting room. Check fields.';
            if (status === 409) {
                setScheduleFormErrors({ room_name: message });
            }
            setAlertPopup({
                show: true,
                title: status === 409 ? 'Room Occupied' : 'Error',
                message
            });
            console.error(error);
        }

    };
    const handleJoinByCode = async (e) => {
        e.preventDefault();
        if (!meetingCodeInput.trim()) return;
        setJoiningMeeting(true);
        try {
            let cleanId = meetingCodeInput.trim();
            // If it's a URL or contains query parameters, try to extract 'room=' or last slash segment

            if (cleanId.includes('room=')) {
                const urlParams = new URLSearchParams(cleanId.substring(cleanId.indexOf('?')));
                cleanId = urlParams.get('room');
            } else if (cleanId.includes('/')) {
                const parts = cleanId.split('/');
                const lastSegment = parts[parts.length - 1];
                cleanId = lastSegment.replace(/[^0-9]/g, '');
            } else {
                cleanId = cleanId.replace(/[^0-9]/g, '');
            }

            if (!cleanId) {
                setAlertPopup({
                    show: true,
                    title: 'Invalid Input',
                    message: 'Invalid meeting code or URL format.'
                });
                setJoiningMeeting(false);
                return;
            }

            const response = await api.get(`/collab-meetings/meeting/${cleanId}`);
            if (response.data && response.data.status === 'success') {
                const meeting = response.data.data;
                setActiveMeeting({ id: meeting.id, name: meeting.title });
            } else {
                setAlertPopup({
                    show: true,
                    title: 'Not Found',
                    message: 'Meeting room not found.'
                });
            }
        } catch (error) {
            setAlertPopup({
                show: true,
                title: 'Not Found',
                message: 'Meeting room not found or invalid format.'
            });
            console.error(error);
        } finally {
            setJoiningMeeting(false);
        }
    };
    const copyToClipboard = () => {
        navigator.clipboard.writeText(createdMeetingLink);
        setAlertPopup({
            show: true,
            title: 'Copied',
            message: 'Meeting link copied to clipboard!'
        });
    };
    if (!user) {
        if (checkingGuestMeeting) {
            return (
                <div className="min-h-screen bg-slate-50 text-slate-900 flex items-center justify-center font-sans">
                    <div className="flex flex-col items-center gap-4">
                        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-main"></div>
                        <p className="text-slate-500 text-sm font-semibold">Checking meeting status...</p>
                    </div>
                </div>
            );
        }

        if (guestError && !guestMeetingTitle) {
            return (
                <div className="min-h-screen bg-slate-50 text-slate-900 flex items-center justify-center font-sans px-4">
                    <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8 text-center shadow-xl">
                        <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-slate-900 mb-2">Access Denied</h2>
                        <p className="text-slate-550 mb-6">{guestError}</p>
                        <a href="/" className="inline-flex items-center justify-center px-5 py-3 text-sm font-medium text-white bg-main hover:bg-mainHover active:bg-red-800 rounded-lg transition duration-200">
                            Go to Login
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <div className="min-h-screen w-full bg-gradient-to-br from-white via-red-50/30 to-white text-slate-900 flex items-center justify-center font-sans relative overflow-hidden px-4 py-12">
                {/* Decorative background grid */}
                <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:14px_24px] pointer-events-none"></div>
                {/* Soft red background blobs */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-40 -left-40 h-[500px] w-[500px] rounded-full bg-main/5 blur-3xl"></div>
                    <div className="absolute -bottom-40 -right-40 h-[500px] w-[500px] rounded-full bg-red-100/30 blur-3xl"></div>
                    <div className="absolute top-[30%] right-[20%] h-[300px] w-[300px] rounded-full bg-main/5 blur-[120px] animate-pulse"></div>
                </div>
                {/* Responsive Layout Container */}
                <div className="w-full max-w-6xl z-10 flex flex-col lg:flex-row items-center justify-center gap-12">
                    {/* Left Floating Card: Mock Video feeds (Hidden on mobile) */}
                    <div className="hidden lg:flex flex-col gap-6 w-72 shrink-0">
                        {/* Card 1: Host Video Preview */}
                        <div className="bg-white/80 backdrop-blur-md border border-slate-200/60 p-3 rounded-2xl shadow-lg relative overflow-hidden group hover:scale-[1.02] transition-all duration-300">
                            <div className="relative h-44 rounded-xl overflow-hidden bg-slate-100">
                                <img
                                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=300&auto=format&fit=crop"
                                    alt="Marcus Vance"
                                    className="w-full h-full object-cover object-center filter brightness-95"
                                />
                                <div className="absolute top-2 left-2 bg-main text-white text-[9px] font-black uppercase px-2 py-0.5 rounded-md tracking-wider flex items-center gap-1">
                                    <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
                                    Host
                                </div>
                                <div className="absolute bottom-2 left-2 right-2 flex justify-between items-center">
                                    <span className="text-[10px] text-white bg-slate-900/60 backdrop-blur-md px-2 py-1 rounded font-bold">
                                        Marcus Vance
                                    </span>
                                    <div className="flex gap-1">
                                        <span className="bg-emerald-500 text-white p-1 rounded-md text-[10px] leading-none">
                                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z" />
                                            </svg>
                                        </span>
                                        <span className="bg-emerald-500 text-white p-1 rounded-md text-[10px] leading-none">
                                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Card 2: Participant Face Grid */}
                        <div className="bg-white/80 backdrop-blur-md border border-slate-200/60 p-4 rounded-2xl shadow-lg hover:scale-[1.02] transition-all duration-300">
                            <h4 className="text-xs font-black text-slate-800 mb-3 flex items-center justify-between">
                                <span>Already Joined</span>
                                <span className="bg-red-50 text-main text-[10px] px-2 py-0.5 rounded-full font-bold">3 Online</span>
                            </h4>
                            <div className="flex flex-col gap-2.5">
                                <div className="flex items-center gap-3">
                                    <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=100&auto=format&fit=crop" className="w-8 h-8 rounded-full object-cover" />
                                    <div className="text-left flex-grow">
                                        <p className="text-xs font-bold text-slate-700">David K. (Design)</p>
                                        <p className="text-[9px] text-slate-400 font-medium">Presenter</p>
                                    </div>
                                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=100&auto=format&fit=crop" className="w-8 h-8 rounded-full object-cover" />
                                    <div className="text-left flex-grow">
                                        <p className="text-xs font-bold text-slate-700">Elena Rostova</p>
                                        <p className="text-[9px] text-slate-400 font-medium">Marketing Head</p>
                                    </div>
                                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Center Card: Join Form */}
                    <div className="max-w-md w-full bg-white/95 backdrop-blur-md border border-slate-200/80 rounded-3xl p-8 shadow-[0_20px_50px_rgba(195,0,16,0.06)] relative z-10 hover:border-slate-300/85 transition-all duration-300 shrink-0">
                        <div className="text-center mb-8">
                            <div className="inline-flex items-center justify-center p-3.5 bg-main/10 rounded-2xl mb-4 text-main">
                                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <h2 className="text-2xl font-black text-slate-900 tracking-tight mb-1">eNova Meet</h2>
                            <p className="text-slate-450 text-xs font-semibold">You've been invited to join</p>
                            <p className="text-main font-black text-lg mt-1 tracking-tight">"{guestMeetingTitle}"</p>
                        </div>
                        <form onSubmit={handleGuestJoinSubmit} className="space-y-5">
                            <div>
                                <label className="block text-slate-650 text-xs font-extrabold uppercase tracking-wider mb-2">
                                    Your Name
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-0 pl-3.5 flex items-center text-slate-400">
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                                        </svg>
                                    </span>
                                    <input
                                        type="text"
                                        value={guestName}
                                        onChange={(e) => setGuestName(e.target.value)}
                                        placeholder="Enter your full name"
                                        className="w-full bg-slate-50/50 border border-slate-200 focus:border-main focus:ring-1 focus:ring-main focus:bg-white rounded-xl pl-10 pr-4 py-3.5 text-slate-900 placeholder-slate-400 outline-none transition duration-200 text-sm font-semibold"
                                        required
                                    />
                                </div>
                            </div>
                            {guestError && (
                                <div className="bg-red-50/30 border border-red-200 text-red-650 px-4 py-3 rounded-xl text-xs leading-relaxed font-bold">
                                    {guestError}
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={guestLoading}
                                className="w-full inline-flex items-center justify-center px-4 py-3.5 text-sm font-bold text-white bg-main hover:bg-mainHover active:bg-red-800 disabled:opacity-50 rounded-xl shadow-lg hover:shadow-main/20 transition duration-200"
                            >
                                {guestLoading ? (
                                    <div className="flex items-center gap-2">
                                        <div className="animate-spin rounded-full h-4 w-4 border-2 border-white/30 border-t-white"></div>
                                        <span>Joining...</span>
                                    </div>
                                ) : (
                                    "Join Meeting"
                                )}
                            </button>
                        </form>
                        <div className="mt-8 pt-6 border-t border-slate-100 text-center">
                            <span className="text-slate-450 text-xs font-semibold">Have an account?</span>
                            <a href={`/?redirectTo=${encodeURIComponent(`/meetings?room=${roomId}`)}`} className="text-main hover:text-mainHover text-xs font-bold ml-1.5 transition duration-150">
                                Log In
                            </a>
                        </div>
                    </div>
                    {/* Right Floating Card: AI & Live Transcription Features (Hidden on mobile) */}
                    <div className="hidden lg:flex flex-col gap-6 w-72 shrink-0">
                        <div className="bg-white/80 backdrop-blur-md border border-slate-200/60 p-4 rounded-2xl shadow-lg hover:scale-[1.02] transition-all duration-300">
                            <h4 className="text-xs font-black text-slate-800 mb-3 flex items-center gap-2">
                                <span className="w-2 h-2 rounded-full bg-main animate-pulse"></span>
                                <span>AI Copilot Status</span>
                            </h4>
                            <div className="space-y-3">
                                <div className="bg-slate-50 border border-slate-100 rounded-xl p-3 text-left">
                                    <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-1">Live transcription</p>
                                    <p className="text-xs text-slate-650 italic leading-relaxed">
                                        "Let's review the marketing proposal and update the milestones for Q3..."
                                    </p>
                                </div>
                                <div className="space-y-2">
                                    <div className="flex items-center gap-2 text-slate-600 text-xs font-medium">
                                        <svg className="w-4 h-4 text-emerald-500 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                        <span>Speech Recognition Ready</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-slate-600 text-xs font-medium">
                                        <svg className="w-4 h-4 text-emerald-500 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                        <span>Live Action Item Capture</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white/80 backdrop-blur-md border border-slate-200/60 p-4 rounded-2xl shadow-lg text-center hover:scale-[1.02] transition-all duration-300">
                            <div className="w-10 h-10 rounded-full bg-main/10 text-main flex items-center justify-center mx-auto mb-2.5">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
                                </svg>
                            </div>
                            <p className="text-xs font-black text-slate-800">Secure & Encrypted</p>
                            <p className="text-[10px] text-slate-400 mt-1 leading-relaxed">All video streams and minutes are fully encrypted in transit.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (activeMeeting) {
        return (
            <CollabMeetingRoom
                meetingId={activeMeeting.id}
                meetingTitle={activeMeeting.name}
                onLeave={() => {
                    setActiveMeeting(null);
                    if (user && String(user.role_id) === '28') {
                        localStorage.removeItem('token');
                        setUser(null);
                    } else {
                        fetchMeetings();
                    }
                }}
            />
        );
    }

    return (
        <Layout noSidebar={true}>
            <div className={`bg-slate-50 text-slate-900 font-sans flex flex-col justify-between relative overflow-hidden ${(!loading && meetings.length === 0) ? 'min-h-[calc(100vh-115px)]' : ''}`}>
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-main/10 blur-3xl"></div>
                    <div className="absolute top-28 right-0 h-96 w-96 rounded-full bg-red-100/70 blur-3xl"></div>
                    <div className="absolute bottom-8 left-1/3 h-64 w-64 rounded-full bg-slate-200/70 blur-3xl"></div>
                </div>
                {/* Main Area */}
                <main className="relative z-30 flex-grow px-5 py-10 md:px-8 md:py-14">
                    <div className="max-w-7xl mx-auto">
                        <section className="relative overflow-visible rounded-[2rem] border border-slate-200/70 bg-white/90 px-6 py-10 shadow-[0_24px_70px_rgba(15,23,42,0.10)] backdrop-blur md:px-10 lg:px-14">
                        <div className="absolute inset-x-10 top-0 h-px bg-gradient-to-r from-transparent via-main/30 to-transparent"></div>
                        <div className="absolute right-8 top-8 hidden h-24 w-24 rounded-full border border-red-100 lg:block"></div>
                        <div className="absolute right-20 top-20 hidden h-8 w-8 rounded-full bg-main/10 lg:block"></div>
                        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-[0.92fr_1.08fr]">
                            {/* Left Actions Column */}

                            <div className={`relative space-y-7 text-center lg:text-left ${dropdownOpen ? 'z-20' : 'z-10'}`}>
                                <div className="inline-flex items-center gap-2 rounded-full border border-red-100 bg-white px-3.5 py-2 text-[11px] font-extrabold uppercase tracking-[0.28em] text-main shadow-sm">
                                    <span className="flex h-2 w-2 rounded-full bg-main"></span>
                                    eNova Meet workspace
                                </div>
                                <div className="space-y-5">
                                    <h1 className="mx-auto max-w-4xl text-4xl font-black leading-[1.05] tracking-tight text-slate-950 md:text-6xl lg:mx-0">
                                        Seamless <span className="font-heading italic text-main">video conferencing</span> for every team conversation
                                    </h1>
                                    <p className="mx-auto max-w-2xl text-sm leading-7 text-slate-500 md:text-base lg:mx-0">
                                        Start instant calls, schedule secure rooms, and join shared meeting links from one polished collaboration hub.
                                    </p>
                                </div>
                                {/* Interactive Buttons with Dropdown */}

                                <div className={`relative mx-auto max-w-xl rounded-2xl border border-white bg-white/95 p-2.5 shadow-[0_16px_40px_rgba(15,23,42,0.10)] lg:mx-0 ${dropdownOpen ? 'z-30' : 'z-10'}`}>
                                    <div className="flex flex-col items-stretch gap-2.5 sm:flex-row sm:items-center">
                                        {/* New Meeting Button and Dropdown Menu */}

                                        <div className="relative" ref={dropdownRef}>
                                            <button
                                                onClick={() => setDropdownOpen(!dropdownOpen)}

                                                className="flex w-full items-center justify-center gap-2 rounded-xl bg-main px-5 py-3 text-xs font-extrabold text-white shadow-lg shadow-main/25 transition-all hover:-translate-y-0.5 hover:bg-mainHover sm:w-auto"
                                            >
                                                <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                                </svg>
                                                New meeting
                                            </button>
                                            {/* Dropdown Overlay */}

                                            {dropdownOpen && (
                                                <div className="absolute left-0 z-50 mt-3 w-80 overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-2 text-sm shadow-2xl shadow-slate-900/15">
                                                    <button
                                                        onClick={handleCreateLaterClick}

                                                        className="flex w-full items-center gap-3 rounded-xl px-3.5 py-3 text-left font-semibold text-slate-700 transition-colors hover:bg-red-50 hover:text-slate-950"
                                                    >
                                                        <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-main/10 text-main">
                                                            <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>
                                                        </span>
                                                        <span>Create a meeting for later</span>
                                                    </button>
                                                    <button
                                                        onClick={handleStartInstantClick}

                                                        className="flex w-full items-center gap-3 rounded-xl px-3.5 py-3 text-left font-semibold text-slate-700 transition-colors hover:bg-red-50 hover:text-slate-950"
                                                    >
                                                        <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-main/10 text-main">
                                                            <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg>
                                                        </span>
                                                        <span>Start an instant meeting</span>
                                                    </button>
                                                    <button
                                                        onClick={handleScheduleCalendar}

                                                        className="flex w-full items-center gap-3 rounded-xl px-3.5 py-3 text-left font-semibold text-slate-700 transition-colors hover:bg-blue-50 hover:text-slate-950"
                                                    >
                                                        <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-blue-100 text-blue-700">
                                                            <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                                                        </span>
                                                        <span>Schedule in Collab Calendar</span>
                                                    </button>
                                                </div>
                                            )}

                                        </div>
                                        {/* Join Code Input Form */}

                                        <form onSubmit={handleJoinByCode} className="flex flex-col sm:flex-row flex-grow gap-2">
                                            <div className="relative flex-grow">
                                                <svg className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                                                </svg>
                                                <input
                                                    type="text"
                                                    placeholder="Enter a code or link"
                                                    value={meetingCodeInput}
                                                    onChange={(e) => setMeetingCodeInput(e.target.value)}
                                                    className="w-full rounded-xl border border-slate-200 bg-slate-50 py-3 pl-10 pr-4 text-xs font-semibold text-slate-900 shadow-inner outline-none transition-all placeholder:text-slate-400 focus:border-main focus:bg-white focus:ring-2 focus:ring-main/10"
                                                />
                                            </div>
                                            <button
                                                type="submit"
                                                disabled={!meetingCodeInput.trim() || joiningMeeting}
                                                className="rounded-xl bg-slate-950 px-5 py-3 w-full sm:w-auto text-xs font-extrabold text-white shadow-sm transition-all hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400 text-center"
                                            >
                                                Join
                                            </button>

                                            {/* Admin Provider Management Button */}
                                            {(user?.role === 'admin' || user?.role === 'super_admin' || user?.user_id === 1 || user?.user_id === '1') && (
                                                <button
                                                    type="button"
                                                    onClick={() => setShowProviderAdmin(true)}
                                                    className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 w-full sm:w-auto text-xs font-extrabold text-main shadow-sm transition-all hover:bg-red-100 flex items-center justify-center gap-2"
                                                    title="Manage Zoom/Google Meet Accounts"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                                    <span className="hidden sm:inline">Providers</span>
                                                    <span className="inline sm:hidden">Manage Providers</span>
                                                </button>
                                            )}
                                        </form>
                                    </div>
                                </div>
                                <div className="flex flex-wrap items-center justify-center gap-4 text-xs font-bold text-slate-500 lg:justify-start">
                                    <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-emerald-500"></span> Secure rooms</span>
                                    <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-blue-500"></span> Calendar scheduling</span>
                                    <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-main"></span> Invite links</span>
                                </div>
                            </div>
                            {/* Right Column - Illustration Room Graphic */}

                            <div className="relative z-10 flex justify-center lg:justify-end">
                                <div className="absolute -left-6 top-14 hidden rounded-2xl bg-white px-4 py-3 text-xs font-extrabold text-slate-700 shadow-xl shadow-slate-900/10 lg:block">
                                    <span className="mr-2 inline-flex h-2 w-2 rounded-full bg-emerald-500"></span>
                                    Recording 24:01:45
                                </div>
                                <div className="w-full max-w-2xl rounded-[2rem] border border-white/80 bg-white p-3 shadow-[0_26px_80px_rgba(15,23,42,0.14)]">
                                    <div className="overflow-hidden rounded-[1.5rem] border border-slate-100 bg-slate-50">
                                        <div className="flex items-center justify-between border-b border-slate-200/80 bg-white px-5 py-3">
                                            <div className="flex items-center gap-3">
                                                <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-main/10 text-main">
                                                    <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.4" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
                                                </div>
                                                <div>
                                                    <p className="text-xs font-extrabold text-slate-900">Weekly Product Sync</p>
                                                    <p className="text-[10px] font-semibold text-slate-400">Share link enabled</p>
                                                </div>
                                            </div>
                                            <div className="flex -space-x-2">
                                                <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=80" className="h-8 w-8 rounded-full border-2 border-white object-cover" alt="Participant" />
                                                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=80" className="h-8 w-8 rounded-full border-2 border-white object-cover" alt="Participant" />
                                                <span className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-main text-[10px] font-bold text-white">+5</span>
                                            </div>
                                        </div>
                                        <div className="grid gap-3 p-4 lg:grid-cols-[1fr_13rem]">
                                            <div className="flex flex-col gap-3 h-full">
                                                <div className="relative aspect-video overflow-hidden rounded-2xl bg-slate-900">
                                                    <img src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=900" className="h-full w-full object-cover opacity-90" alt="Meeting presenter" />
                                                    <div className="absolute left-4 top-4 rounded-full bg-main px-3 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white">Live</div>
                                                    <div className="absolute bottom-4 left-4 rounded-full bg-slate-950/70 px-3 py-1.5 text-xs font-bold text-white backdrop-blur">Hr eNova</div>
                                                    <div className="absolute bottom-4 right-4 flex items-center gap-2">
                                                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-lg">
                                                            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.4" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-14 0m7 7v3m-4 0h8m-4-17a3 3 0 00-3 3v4a3 3 0 006 0V7a3 3 0 00-3-3z" /></svg>
                                                        </span>
                                                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-main text-white shadow-lg">
                                                            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.4" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-3 gap-3 flex-1">
                                                    {[
                                                        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=260',
                                                        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=260',
                                                        'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=260'
                                                    ].map((src, index) => (
                                                        <div key={src} className="relative overflow-hidden rounded-xl bg-slate-200 h-full min-h-[80px]">
                                                            <img src={src} className="h-full w-full object-cover" alt={`Participant ${index + 1}`} />
                                                            <span className="absolute bottom-2 left-2 rounded-full bg-white/90 px-2 py-0.5 text-[9px] font-bold text-slate-700">Guest {index + 1}</span>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                            <aside className="space-y-3">
                                                <div className="rounded-2xl bg-white p-3 shadow-sm">
                                                    <div className="mb-3 flex items-center justify-between">
                                                        <span className="text-[10px] font-extrabold uppercase tracking-wider text-slate-400">Participants</span>
                                                        <span className="rounded-full bg-main/10 px-2 py-0.5 text-[10px] font-bold text-main">13</span>
                                                    </div>
                                                    <div className="space-y-2">
                                                        {['Sowndar', 'Ranjith', 'Pharithivel'].map((name, index) => (
                                                            <div key={name} className="flex items-center justify-between rounded-xl bg-slate-50 px-2.5 py-2">
                                                                <div className="flex items-center gap-2">
                                                                    <span className={`flex h-7 w-7 items-center justify-center rounded-full text-[10px] font-bold text-white ${index === 0 ? 'bg-main' : index === 1 ? 'bg-red-400' : 'bg-slate-500'}`}>{name[0]}</span>
                                                                    <span className="text-[10px] font-bold text-slate-700">{name}</span>
                                                                </div>
                                                                <span className="h-2 w-2 rounded-full bg-emerald-500"></span>
                                                            </div>
                                                        ))}

                                                    </div>
                                                </div>
                                                <div className="rounded-2xl bg-white p-3 shadow-sm">
                                                    <span className="text-[10px] font-extrabold uppercase tracking-wider text-slate-400">Live chats</span>
                                                    <div className="mt-3 space-y-2 text-[10px]">
                                                        <div className="rounded-xl bg-red-50 px-3 py-2 text-slate-600">Can we attach the latest project deck?</div>
                                                        <div className="ml-5 rounded-xl bg-main px-3 py-2 text-white">Shared with everyone.</div>
                                                    </div>
                                                </div>
                                            </aside>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
            {/* Footer Active Rooms Grid & Analytics */}

            {(loading || meetings.length > 0) && (
                <footer className="relative z-10 px-5 pb-8 md:px-8 space-y-6">
                    {/* Unified Dashboard Analytics / Stats */}

                    <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div className="bg-white/80 border border-slate-200/60 rounded-2xl p-4 shadow-sm backdrop-blur flex items-center gap-3">
                            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-100 text-emerald-600">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" /></svg>
                            </span>
                            <div className="text-left">
                                <p className="text-[9px] font-extrabold uppercase text-slate-400">Active Now</p>
                                <h4 className="text-base font-black text-slate-900">{meetings.filter(m => m.status === 'in_progress').length} Rooms</h4>
                            </div>
                        </div>
                        <div className="bg-white/80 border border-slate-200/60 rounded-2xl p-4 shadow-sm backdrop-blur flex items-center gap-3">
                            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-100 text-blue-600">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                            </span>
                            <div className="text-left">
                                <p className="text-[9px] font-extrabold uppercase text-slate-400">Upcoming Scheduled</p>
                                <h4 className="text-base font-black text-slate-900">{meetings.filter(m => m.status !== 'completed' && m.status !== 'cancelled').length} Slots</h4>
                            </div>
                        </div>
                        <div className="bg-white/80 border border-slate-200/60 rounded-2xl p-4 shadow-sm backdrop-blur flex items-center gap-3">
                            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-purple-100 text-purple-650">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5" /></svg>
                            </span>
                            <div className="text-left">
                                <p className="text-[9px] font-extrabold uppercase text-slate-400">Physical Rooms</p>
                                <h4 className="text-base font-black text-slate-900">{meetings.filter(m => m.meeting_type === 'physical').length} Venues</h4>
                            </div>
                        </div>
                        <div className="bg-white/80 border border-slate-200/60 rounded-2xl p-4 shadow-sm backdrop-blur flex items-center gap-3">
                            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-pink-100 text-pink-600">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>
                            </span>
                            <div className="text-left">
                                <p className="text-[9px] font-extrabold uppercase text-slate-400">Hybrid Broadcasters</p>
                                <h4 className="text-base font-black text-slate-900">{meetings.filter(m => m.meeting_type?.startsWith('hybrid')).length} Integrations</h4>
                            </div>
                        </div>
                    </div>
                    <div className="max-w-7xl mx-auto rounded-[2rem] border border-white/70 bg-white/85 p-6 shadow-[0_20px_60px_rgba(15,23,42,0.08)] backdrop-blur md:p-8">
                        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                            <div>
                                <p className="text-[10px] font-extrabold uppercase tracking-[0.24em] text-main text-left">Rooms dashboard</p>
                                <h3 className="mt-1 text-xl font-black text-slate-950 text-left">Your Active Meeting Rooms</h3>
                            </div>
                            <button onClick={fetchMeetings} className="flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-extrabold text-main shadow-sm transition-all hover:border-main/30 hover:bg-main/5 hover:text-mainHover">
                                <svg className="h-4 w-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                </svg>
                                <span>Refresh List</span>
                            </button>
                        </div>
                        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
                            {loading ? (
                                <div className="col-span-full py-8 text-center text-sm text-slate-400">
                                    <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-main border-t-transparent"></span>
                                </div>
                            ) : (
                                meetings.slice(0, visibleCount).map(meeting => (
                                    <div
                                        key={meeting.id}

                                        onClick={() => setActiveMeeting({ id: meeting.id, name: meeting.title })}

                                        className="group relative flex cursor-pointer flex-col justify-between overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 text-left shadow-sm transition-all hover:-translate-y-1 hover:border-main/30 hover:shadow-xl hover:shadow-main/10"
                                    >
                                        <div className="absolute right-0 top-0 h-24 w-24 translate-x-8 -translate-y-8 rounded-full bg-red-50 transition-all group-hover:bg-main/10"></div>
                                        <div className="relative">
                                            <div className="mb-4 flex items-start justify-between gap-3">
                                                <div className="flex items-center gap-2">
                                                    <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-extrabold text-slate-600">Room #{meeting.id}</span>
                                                    {(meeting.created_by == user?.user_id || user?.role_id == 1) && (
                                                        <div className="flex items-center gap-1">
                                                            <button
                                                                onClick={(e) => handleEditMeeting(e, meeting)}
                                                                title="Edit Meeting Schedule"
                                                                className={`rounded-full p-1 transition-all ${
                                                                    (meeting.status && meeting.status !== 'scheduled') || (new Date(meeting.start_time.replace(/-/g, "/")).getTime() <= Date.now())
                                                                        ? 'text-slate-300 cursor-not-allowed opacity-40'
                                                                        : 'text-slate-500 hover:bg-slate-100 hover:text-slate-700'
                                                                }`}
                                                            >
                                                                <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                                </svg>
                                                            </button>
                                                            <button
                                                                onClick={(e) => handleDeleteMeeting(e, meeting.id)}
                                                                title="Delete Meeting Room"
                                                                className="rounded-full p-1 text-red-500 transition-all hover:bg-red-50 hover:text-red-700"
                                                            >
                                                                <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    )}

                                                </div>
                                                <span className={`flex items-center gap-1.5 rounded-full bg-white/80 px-2 py-1 text-[10px] font-extrabold shadow-sm ${
                                                    meeting.status === 'in_progress' ? 'text-emerald-600' :
                                                    meeting.status === 'completed' ? 'text-slate-500' :
                                                    meeting.status === 'cancelled' ? 'text-red-500' : 'text-blue-600'
                                                }`}>
                                                    <span className={`h-2 w-2 rounded-full ${
                                                        meeting.status === 'in_progress' ? 'bg-emerald-500 animate-pulse' :
                                                        meeting.status === 'completed' ? 'bg-slate-400' :
                                                        meeting.status === 'cancelled' ? 'bg-red-500' : 'bg-blue-500'
                                                    }`}></span>
                                                    {meeting.status ? meeting.status.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase()) : 'Scheduled'}

                                                </span>
                                            </div>
                                            {/* Beautiful custom icon container matching type */}

                                            <div className={`mb-4 flex h-12 w-12 items-center justify-center rounded-2xl transition-all group-hover:scale-105 ${
                                                meeting.meeting_type === 'physical' ? 'bg-blue-100 text-blue-600' :
                                                meeting.meeting_type === 'hybrid_zoom' ? 'bg-purple-100 text-purple-650' :
                                                meeting.meeting_type === 'hybrid_google_meet' ? 'bg-pink-100 text-pink-650' : 'bg-main/10 text-main'
                                            }`}>
                                                {meeting.meeting_type === 'physical' ? (
                                                    <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5" /></svg>
                                                ) : (
                                                    <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2.4" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                                    </svg>
                                                )}

                                            </div>
                                            <h4 className="mb-1 line-clamp-2 font-extrabold text-slate-950 transition-colors group-hover:text-main text-left">{meeting.title}</h4>
                                            {/* Render physical details if physical */}

                                            {meeting.meeting_type === 'physical' ? (
                                                <div className="mb-3 p-2 bg-slate-50 rounded-xl border border-slate-100 text-left">
                                                    <p className="text-[10px] font-bold text-slate-700 truncate">🏢 {meeting.room_name || 'Meeting Room'}</p>
                                                    <p className="text-[9px] text-slate-450 font-semibold">{meeting.building || 'HQ'} • Floor {meeting.floor || 'N/A'} (Max: {meeting.seating_capacity || 'N/A'})</p>
                                                    {meeting.check_in_status && (
                                                        <span className={`inline-block text-[8px] font-extrabold uppercase mt-1 px-1.5 py-0.5 rounded ${
                                                            meeting.check_in_status === 'checked_in' ? 'bg-emerald-500/10 text-emerald-600' : 'bg-red-500/10 text-red-650'
                                                        }`}>
                                                            {meeting.check_in_status.replace('_', ' ')}

                                                        </span>
                                                    )}

                                                </div>
                                            ) : (
                                                <div className="mb-4 text-left">
                                                    <p className="text-[10px] text-slate-450 font-semibold">
                                                        {meeting.meeting_type === 'online' ? (
                                                            'Internal video chat room link'
                                                        ) : meeting.external_meeting_url ? (
                                                            `External Link: ${meeting.external_meeting_url.substring(0, 30)}...`
                                                        ) : (
                                                            <span className="text-red-500 font-bold">Zoom/Meet failed (Click Join Room to resolve)</span>
                                                        )}
                                                    </p>
                                                </div>
                                            )}

                                            <p className="mb-5 text-[11px] font-semibold text-slate-450 text-left">
                                                {new Date(meeting.start_time).toLocaleString()}
                                            </p>

                                            {meeting.participants && meeting.participants.length > 0 && (
                                                <div className="flex items-center gap-1.5 mb-4">
                                                    <div className="flex -space-x-1.5 overflow-hidden">
                                                        {meeting.participants.slice(0, 5).map((p) => {
                                                            const name = p.name || p.guest_email || p.email || 'Participant';
                                                            const initials = name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
                                                            return p.avatar ? (
                                                                <img
                                                                    key={p.id}
                                                                    src={p.avatar}
                                                                    className="inline-block h-6 w-6 rounded-full ring-2 ring-white object-cover"
                                                                    alt={name}
                                                                    title={name}
                                                                />
                                                            ) : (
                                                                <div
                                                                    key={p.id}
                                                                    className="inline-block h-6 w-6 rounded-full bg-main/20 text-main ring-2 ring-white text-[8px] font-extrabold flex items-center justify-center uppercase"
                                                                    title={name}
                                                                >
                                                                    {initials}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    {meeting.participants.length > 5 && (
                                                        <span className="text-[10px] font-extrabold text-slate-400">
                                                            +{meeting.participants.length - 5}
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="relative flex items-center justify-between border-t border-slate-100 pt-4">
                                            <span className={`rounded-full px-2.5 py-1 text-[9px] font-extrabold uppercase tracking-wider ${
                                                meeting.status === 'completed' ? 'bg-slate-100 text-slate-500' :
                                                meeting.meeting_type === 'physical' ? 'bg-blue-100 text-blue-600' :
                                                meeting.meeting_type?.startsWith('hybrid') ? 'bg-purple-100 text-purple-650' : 'bg-emerald-100 text-emerald-600'
                                            }`}>
                                                {meeting.status === 'completed' ? 'offline' : (meeting.meeting_type ? meeting.meeting_type.replace('_', ' ') : 'online')}
                                            </span>
                                            <div className="flex items-center gap-2">
                                                {meeting.meeting_type?.startsWith('hybrid') && meeting.external_meeting_url && (
                                                    <a
                                                        href={meeting.external_meeting_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={(e) => e.stopPropagation()}
                                                        className="flex items-center gap-1 text-[10px] font-black bg-purple-50 hover:bg-purple-100 text-purple-700 border border-purple-200 px-2 py-1 rounded-lg transition-all"
                                                    >
                                                        Launch Call
                                                    </a>
                                                )}
                                                <span className="flex items-center text-xs font-extrabold text-main group-hover:text-mainHover">
                                                    Join Room
                                                    <svg className="ml-0.5 h-4 w-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}

                        </div>
                        {!loading && meetings.length > 4 && (
                            <div className="flex justify-center mt-8 pb-2">
                                {visibleCount < meetings.length ? (
                                    <button
                                        onClick={() => setVisibleCount(meetings.length)}

                                        className="flex items-center gap-2 rounded-full bg-main px-6 py-2.5 text-xs font-extrabold text-white shadow-md shadow-main/20 transition-all hover:bg-mainHover"
                                    >
                                        <span>Load More Rooms</span>
                                        <svg className="h-3.5 w-3" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => setVisibleCount(4)}

                                        className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-2.5 text-xs font-extrabold text-slate-700 transition-all hover:bg-slate-50"
                                    >
                                        <span>See Less</span>
                                        <svg className="h-3.5 w-3" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" /></svg>
                                    </button>
                                )}

                            </div>
                        )}

                    </div>
                </footer>
            )}

            {/* Modal for Copyable Links */}

            {showLaterModal && (
                <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl border border-slate-200 text-left space-y-4">
                        <div className="flex justify-between items-center">
                            <h3 className="text-base font-extrabold text-slate-900">Here's the link to your meeting</h3>
                            <button onClick={handleCancelLater} className="text-slate-400 hover:text-slate-600">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <p className="text-xs text-slate-500 leading-relaxed">
                            Copy this meeting link and send it to people you want to meet with. Make sure you save it so you can use it later.
                        </p>
                        <div className="bg-slate-100 rounded-xl p-3 flex justify-between items-center border border-slate-200 gap-2">
                            <span className="text-xs font-medium text-slate-600 select-all truncate">{createdMeetingLink}</span>
                            <button onClick={copyToClipboard} className="text-main flex-shrink-0 hover:text-mainHover p-1 hover:bg-slate-200 rounded transition-colors">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" /></svg>
                            </button>
                        </div>
                        <button
                            onClick={handleConfirmLater}

                            className="bg-main hover:bg-mainHover text-white font-bold w-full py-2.5 rounded-xl transition-all text-xs text-center shadow-md shadow-main/15"
                        >
                            Got it
                        </button>
                    </div>
                </div>
            )}

            {/* Modal for Target Selection before Creating Later Meeting */}
            {showCreateLaterTargetModal && (
                <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-[60] p-4 animate-fadeIn">
                    <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl border border-slate-200 text-left flex flex-col max-h-[80vh] overflow-hidden">
                        <div className="flex justify-between items-center border-b border-slate-100 pb-3 mb-4 shrink-0">
                            <h3 className="text-sm font-extrabold text-slate-950 font-sans">
                                {meetingCreationMode === 'later' ? 'Schedule a Meeting' : 'Who is this meeting for?'}
                            </h3>
                            <button onClick={() => setShowCreateLaterTargetModal(false)} className="text-slate-400 hover:text-slate-600 p-1 hover:bg-slate-100 rounded-full transition-colors">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <div className="overflow-y-auto custom-scrollbar flex-grow space-y-4 text-xs pr-1">
                            <div className="mb-2">
                                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">Meeting Title (Optional)</label>
                                <input
                                    type="text"
                                    placeholder={meetingCreationMode === 'instant' ? "Quick Sync Room..." : "Collaboration Room..."}
                                    value={createMeetingTitle}
                                    onChange={(e) => setCreateMeetingTitle(e.target.value)}
                                    className="w-full bg-white border border-slate-200 rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none shadow-sm"
                                />
                            </div>
                            {meetingCreationMode === 'later' && (
                                <div className="flex gap-4 mb-4">
                                    <div className="flex-1">
                                        <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">Date *</label>
                                        <input
                                            type="date"
                                            value={createLaterDate}
                                            onChange={(e) => setCreateLaterDate(e.target.value)}
                                            className="w-full bg-white border border-slate-200 rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none shadow-sm"
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">Time *</label>
                                        <input
                                            type="time"
                                            value={createLaterTime}
                                            onChange={(e) => setCreateLaterTime(e.target.value)}
                                            className="w-full bg-white border border-slate-200 rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none shadow-sm"
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="space-y-3">
                                {/* Option 1: Selective Employees */}
                                <label className="flex items-start gap-2.5 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={createLaterShowEmployees}
                                        onChange={(e) => setCreateLaterShowEmployees(e.target.checked)}
                                        className="mt-0.5 border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer rounded"
                                    />
                                    <div className="-mt-0.5">
                                        <span className="font-semibold text-slate-750">Employees</span>
                                        <p className="text-[10px] text-slate-400">Select employees to assign this meeting to.</p>
                                    </div>
                                </label>

                                {/* Employee Selection Dropdown / Checkbox List */}
                                {createLaterShowEmployees && (
                                    <div className="pl-6 mt-1 space-y-1.5 animate-fadeIn">
                                        <div className="flex justify-between items-center px-1 mb-1">
                                            <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Select Employees</span>
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="Search employees..."
                                            value={employeeSearchQuery}
                                            onChange={(e) => setEmployeeSearchQuery(e.target.value)}
                                            className={`w-full bg-white border ${scheduleFormErrors.selective_employees ? 'border-red-500' : 'border-slate-200'} rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none placeholder-slate-400 shadow-sm`}
                                        />
                                        <div className="bg-white rounded-lg border border-slate-200 max-h-40 overflow-y-auto custom-scrollbar shadow-inner flex flex-col">
                                            {(() => {
                                                const filteredEmployeesForSelection = allEmployeesList.filter(emp =>
                                                    emp.name.toLowerCase().includes(employeeSearchQuery.toLowerCase()) ||
                                                    (emp.email && emp.email.toLowerCase().includes(employeeSearchQuery.toLowerCase()))
                                                );
                                                
                                                return (
                                                    <>
                                                        {allEmployeesList.length > 0 && (
                                                            <div className="flex justify-end sticky top-0 bg-white z-10 pt-2 pb-1 px-2 border-b border-slate-100">
                                                                <label className="flex items-center gap-2 cursor-pointer hover:bg-slate-50 rounded px-1 py-0.5">
                                                                    <span className="text-slate-700 text-[10px] font-bold uppercase tracking-wider">Select All</span>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={filteredEmployeesForSelection.length > 0 && filteredEmployeesForSelection.every(emp => selectedEmployees.includes(emp.user_id))}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                const newSelected = [...selectedEmployees];
                                                                                filteredEmployeesForSelection.forEach(emp => {
                                                                                    if (!newSelected.includes(emp.user_id)) newSelected.push(emp.user_id);
                                                                                });
                                                                                setSelectedEmployees(newSelected);
                                                                            } else {
                                                                                const filteredIds = filteredEmployeesForSelection.map(emp => emp.user_id);
                                                                                setSelectedEmployees(prev => prev.filter(id => !filteredIds.includes(id)));
                                                                            }
                                                                        }}
                                                                        className="rounded-sm border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer"
                                                                    />
                                                                </label>
                                                            </div>
                                                        )}
                                                        <div className="px-2 pb-2 pt-1 space-y-1">
                                                            {allEmployeesList.length === 0 ? (
                                                                <span className="text-[10px] text-slate-500">Loading employees...</span>
                                                            ) : filteredEmployeesForSelection.length === 0 ? (
                                                                <span className="text-[10px] text-slate-400 block p-1">No employees found</span>
                                                            ) : (
                                                                filteredEmployeesForSelection.map(emp => (
                                                                    <label key={emp.user_id} className="flex items-center justify-between cursor-pointer py-0.5 hover:bg-slate-50 rounded px-1">
                                                                        <span className="text-slate-650 text-[11px]">{emp.name}</span>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedEmployees.includes(emp.user_id)}
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    setSelectedEmployees(prev => [...prev, emp.user_id]);
                                                                                } else {
                                                                                    setSelectedEmployees(prev => prev.filter(id => id !== emp.user_id));
                                                                                }
                                                                            }}
                                                                            className="rounded-sm border-slate-350 bg-white text-blue-500 focus:ring-0 w-3 h-3 cursor-pointer"
                                                                        />
                                                                    </label>
                                                                ))
                                                            )}
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                )}

                                {/* Option 2: Customers */}
                                <label className="flex items-start gap-2.5 cursor-pointer mt-4">
                                    <input
                                        type="checkbox"
                                        checked={createLaterShowCustomers}
                                        onChange={(e) => setCreateLaterShowCustomers(e.target.checked)}
                                        className="mt-0.5 border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer rounded"
                                    />
                                    <div className="-mt-0.5">
                                        <span className="font-semibold text-slate-750">Customers (Shareable Link)</span>
                                        <p className="text-[10px] text-slate-400">Generate an open link for customers to join.</p>
                                    </div>
                                </label>

                                {/* Customer Selection Dropdown / Checkbox List */}
                                {createLaterShowCustomers && (
                                    <div className="pl-6 mt-1 animate-fadeIn">
                                        <div className="bg-blue-50 border border-blue-100 rounded-lg p-2.5 flex items-start gap-2">
                                            <svg className="w-4 h-4 text-blue-500 mt-0.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" /></svg>
                                            <p className="text-[10px] text-blue-700 leading-relaxed font-medium">
                                                A shareable link will be provided after creating the meeting.
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="flex gap-3 pt-4 border-t border-slate-100 mt-2 shrink-0">
                            <button
                                onClick={() => setShowCreateLaterTargetModal(false)}
                                className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center border border-slate-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleTargetSubmit}
                                className="bg-main hover:bg-mainHover text-white font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center shadow-md shadow-main/15"
                            >
                                {meetingCreationMode === 'instant' ? 'Start Meeting' : 'Create Meeting'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal for Google Calendar style Scheduling Event Dialog */}

            {showScheduleFormModal && (
                <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
                    <div className="bg-white text-slate-800 rounded-2xl w-full max-w-4xl shadow-2xl border border-slate-200 text-left flex flex-col max-h-[95vh] overflow-hidden">
                        {/* Header */}
                        <div className="flex justify-between items-center px-6 py-4 border-b border-slate-200 bg-slate-50/50">
                            <div className="flex items-center gap-3">
                                <span className="font-extrabold text-sm text-slate-700">Schedule Meeting</span>
                            </div>
                        </div>
                        {/* Form Body */}

                        <form onSubmit={handleSaveScheduledMeeting} className="flex flex-col flex-grow overflow-hidden relative">
                            <div className="p-6 overflow-y-auto flex-grow grid grid-cols-1 lg:grid-cols-3 gap-8 custom-scrollbar">
                                {/* Left Column (Event Details) - Spans 2 Cols on Large */}

                            <div className="lg:col-span-2 space-y-6">
                                {/* Title Field */}

                                <div>
                                    <input
                                        type="text"
                                        placeholder="Add title *"
                                        value={scheduleTitle}
                                        onChange={(e) => setScheduleTitle(e.target.value)}
                                        className={`w-full text-2xl font-bold bg-transparent border-b ${scheduleFormErrors.title ? 'border-red-500' : 'border-slate-200'} outline-none pb-2 focus:border-blue-500 transition-colors text-slate-800 placeholder-slate-400`}
                                        required
                                    />
                                    {scheduleFormErrors.title && (
                                        <p className="text-xs text-red-500 font-semibold mt-1">
                                            {scheduleFormErrors.title}
                                        </p>
                                    )}
                                </div>
                                {/* Date and Time Picker Row */}

                                <div className="flex flex-wrap items-end gap-4 text-xs text-slate-650">
                                    <div className="flex flex-col gap-1">
                                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Date *</label>
                                        <input
                                            type="date"
                                            value={scheduleDate}
                                            onChange={(e) => setScheduleDate(e.target.value)}
                                            className={`bg-white border ${scheduleFormErrors.date ? 'border-red-500' : 'border-slate-200'} rounded-lg px-3 py-1.5 focus:border-blue-500 outline-none text-slate-700 text-xs cursor-pointer shadow-sm hover:border-slate-350 transition-colors`}
                                        />
                                        {scheduleFormErrors.date && (
                                            <p className="text-[9px] text-red-500 font-semibold mt-0.5">{scheduleFormErrors.date}</p>
                                        )}
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Start Time *</label>
                                        <input
                                            type="time"
                                            value={scheduleStartTime}
                                            onChange={(e) => setScheduleStartTime(e.target.value)}
                                            className={`bg-white border ${scheduleFormErrors.start_time ? 'border-red-500' : 'border-slate-200'} rounded-lg px-3 py-1.5 focus:border-blue-500 outline-none text-slate-700 text-xs cursor-pointer shadow-sm hover:border-slate-350 transition-colors`}
                                        />
                                        {scheduleFormErrors.start_time && (
                                            <p className="text-[9px] text-red-500 font-semibold mt-0.5">{scheduleFormErrors.start_time}</p>
                                        )}
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">End Time (Optional)</label>
                                        <div className="flex items-center gap-2">
                                            <span className="text-xs font-semibold text-slate-400">to</span>
                                            <input
                                                type="time"
                                                value={scheduleEndTime}
                                                onChange={(e) => setScheduleEndTime(e.target.value)}
                                                className="bg-white border border-slate-200 rounded-lg px-3 py-1.5 focus:border-blue-500 outline-none text-slate-700 text-xs cursor-pointer shadow-sm hover:border-slate-350 transition-colors"
                                            />
                                        </div>
                                    </div>
                                    {scheduleFormErrors.time && (
                                        <p className="text-xs text-red-500 font-semibold w-full mt-1">
                                            {scheduleFormErrors.time}
                                        </p>
                                    )}
                                </div>
                                {/* Detailed Fields */}

                                <div className="space-y-4">
                                    {/* Meeting Type Selection */}

                                    <div className="flex items-start gap-4">
                                        <svg className="w-5 h-5 text-slate-400 mt-2.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
                                        <div className="flex-grow">
                                            <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5 font-sans">Meeting Type Selection</label>
                                            <select
                                                value={scheduleType}

                                                onChange={(e) => setScheduleType(e.target.value)}

                                                className="bg-white border border-slate-200 rounded-lg px-3 py-2 outline-none text-slate-700 text-xs w-full focus:border-blue-500 cursor-pointer shadow-sm hover:border-slate-350 transition-colors"
                                            >
                                                <option value="online">Online Meeting (Internal WebRTC)</option>
                                                <option value="physical">Physical Meeting (Conference Room Allocation)</option>
                                                <option value="hybrid_zoom">Hybrid Zoom Meeting (External Zoom Link)</option>
                                                <option value="hybrid_google_meet">Hybrid Google Meet (External Meet Link)</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* CONDITIONAL FIELDS: Physical Meetings */}

                                    {scheduleType === 'physical' && (
                                        <div className="p-4 bg-slate-50 rounded-2xl border border-slate-200/80 space-y-4 animate-fadeIn">
                                            <h4 className="text-xs font-black text-slate-700 uppercase tracking-wider">Physical Venue Configuration</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1">Building *</label>
                                                    <input
                                                        type="text"
                                                        placeholder="HQ Block A"
                                                        value={scheduleBuilding}
                                                        onChange={(e) => setScheduleBuilding(e.target.value)}
                                                        className={`w-full bg-white border ${scheduleFormErrors.building ? 'border-red-500' : 'border-slate-200'} rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none`}
                                                    />
                                                    {scheduleFormErrors.building && <p className="text-[9px] text-red-500 font-bold mt-0.5">{scheduleFormErrors.building}</p>}
                                                </div>
                                                <div>
                                                    <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1">Floor *</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Floor 4"
                                                        value={scheduleFloor}
                                                        onChange={(e) => setScheduleFloor(e.target.value)}
                                                        className={`w-full bg-white border ${scheduleFormErrors.floor ? 'border-red-500' : 'border-slate-200'} rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none`}
                                                    />
                                                    {scheduleFormErrors.floor && <p className="text-[9px] text-red-500 font-bold mt-0.5">{scheduleFormErrors.floor}</p>}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1">Conference Room Name *</label>
                                                    <select
                                                        value={scheduleRoomName}
                                                        onChange={(e) => setScheduleRoomName(e.target.value)}
                                                        className={`w-full bg-white border ${scheduleFormErrors.room_name ? 'border-red-500' : 'border-slate-200'} rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none cursor-pointer`}
                                                    >
                                                        <option value="Alpha Suite">Alpha Suite</option>
                                                        <option value="Omega Room">Omega Room</option>
                                                        <option value="Executive Boardroom">Executive Boardroom</option>
                                                        <option value="Innovations Lounge">Innovations Lounge</option>
                                                        <option value="Tech Lab 3">Tech Lab 3</option>
                                                    </select>
                                                    {scheduleFormErrors.room_name && <p className="text-[9px] text-red-500 font-bold mt-0.5">{scheduleFormErrors.room_name}</p>}
                                                </div>
                                                <div>
                                                    <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1">Seating Capacity *</label>
                                                    <input
                                                        type="number"
                                                        value={scheduleSeatingCapacity}
                                                        onChange={(e) => setScheduleSeatingCapacity(e.target.value)}
                                                        className={`w-full bg-white border ${scheduleFormErrors.seating_capacity ? 'border-red-500' : 'border-slate-200'} rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none`}
                                                    />
                                                    {scheduleFormErrors.seating_capacity && <p className="text-[9px] text-red-500 font-bold mt-0.5">{scheduleFormErrors.seating_capacity}</p>}
                                                </div>
                                            </div>
                                            <p className="text-[10px] text-amber-600 font-semibold bg-amber-500/10 p-2 rounded-lg border border-amber-500/20">
                                                * This physical venue allocation will automatically validate availability to prevent double-booking.
                                            </p>
                                        </div>
                                    )}

                                    {/* CONDITIONAL FIELDS: Hybrid Zoom & Google Meet */}

                                    {(scheduleType === 'hybrid_zoom' || scheduleType === 'hybrid_google_meet') && (
                                        <div className="p-4 bg-slate-50 rounded-2xl border border-slate-200/80 space-y-4 animate-fadeIn">
                                            <h4 className="text-xs font-black text-slate-700 uppercase tracking-wider flex items-center gap-2">
                                                {scheduleType === 'hybrid_zoom' ? 'Zoom Integration' : 'Google Meet Integration'}

                                                <span className="text-[9px] font-bold bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded-full normal-case tracking-normal">Auto-Schedule</span>
                                            </h4>
                                            {/* Auto-schedule toggle */}

                                            <div className="flex items-center justify-between bg-white p-3 rounded-xl border border-slate-200 shadow-sm">
                                                <div>
                                                    <span className="text-[11px] font-bold text-slate-700 block">Schedule via API</span>
                                                    <span className="text-[9px] text-slate-400 block mt-0.5">
                                                        Automatically create the meeting using your configured {scheduleType === 'hybrid_zoom' ? 'Zoom' : 'Google Meet'} accounts. If one is busy, the system picks the next available.
                                                    </span>
                                                </div>
                                                <label className="relative inline-flex items-center cursor-pointer ml-3 shrink-0">
                                                    <input
                                                        type="checkbox"
                                                        checked={scheduleAutoSchedule}

                                                        onChange={(e) => setScheduleAutoSchedule(e.target.checked)}

                                                        className="sr-only peer"
                                                    />
                                                    <div className="w-9 h-5 bg-slate-200 rounded-full peer peer-checked:bg-emerald-500 transition-colors after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full"></div>
                                                </label>
                                            </div>
                                            {/* Account availability preview */}

                                            {scheduleAutoSchedule && providerAvailability && (
                                                <div className="bg-white rounded-xl border border-slate-200 p-3 space-y-2">
                                                    <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider block">Account Availability</span>
                                                    {providerAvailability.none_configured ? (
                                                        <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg p-2">
                                                            <svg className="w-4 h-4 text-amber-500 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                                                            <span className="text-[10px] text-amber-700 font-semibold">No {scheduleType === 'hybrid_zoom' ? 'Zoom' : 'Google Meet'} accounts configured. Contact admin or enter a manual URL below.</span>
                                                        </div>
                                                    ) : providerAvailability.all_busy ? (
                                                        <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg p-2">
                                                            <svg className="w-4 h-4 text-red-500 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                                                            <span className="text-[10px] text-red-700 font-semibold">All accounts busy for this time slot. Admin will be notified. You can still enter a manual URL.</span>
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-lg p-2">
                                                            <svg className="w-4 h-4 text-emerald-600 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                                            <span className="text-[10px] text-emerald-700 font-semibold">{providerAvailability.free_accounts} of {providerAvailability.total_accounts} account{providerAvailability.total_accounts > 1 ? 's' : ''} available. Meeting will be auto-created.</span>
                                                        </div>
                                                    )}

                                                    {providerAvailability.accounts && providerAvailability.accounts.length > 0 && (
                                                        <div className="flex flex-wrap gap-1.5 mt-1">
                                                            {providerAvailability.accounts.map(acc => (
                                                                <span key={acc.id} className={`inline-flex items-center gap-1 text-[9px] font-semibold px-2 py-0.5 rounded-full border ${acc.available ? 'bg-emerald-50 border-emerald-200 text-emerald-700' : 'bg-red-50 border-red-200 text-red-600'}`}>
                                                                    <span className={`w-1.5 h-1.5 rounded-full ${acc.available ? 'bg-emerald-500' : 'bg-red-500'}`}></span>
                                                                    {acc.label || acc.email} ({acc.tier})
                                                                </span>
                                                            ))}

                                                        </div>
                                                    )}

                                                </div>
                                            )}

                                            {/* Manual URL - shown when auto-schedule is off or as fallback */}

                                            {!scheduleAutoSchedule && (
                                                <div>
                                                    <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1">External Meeting URL (Manual) *</label>
                                                    <input
                                                        type="url"
                                                        placeholder={scheduleType === 'hybrid_zoom' ? 'https://zoom.us/j/123456789' : 'https://meet.google.com/abc-defg-hij'}
                                                        value={scheduleExternalMeetingUrl}
                                                        onChange={(e) => setScheduleExternalMeetingUrl(e.target.value)}
                                                        className={`w-full bg-white border ${scheduleFormErrors.external_meeting_url ? 'border-red-500' : 'border-slate-200'} rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none`}
                                                    />
                                                    {scheduleFormErrors.external_meeting_url && <p className="text-[9px] text-red-500 font-bold mt-0.5">{scheduleFormErrors.external_meeting_url}</p>}
                                                </div>
                                            )}

                                            <div>
                                                <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1">Meeting Passcode (Optional)</label>
                                                <input
                                                    type="text"
                                                    placeholder="Passcode123"
                                                    value={scheduleMeetingPasscode}

                                                    onChange={(e) => setScheduleMeetingPasscode(e.target.value)}

                                                    className="w-full bg-white border border-slate-200 rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none"
                                                />
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <input type="checkbox" defaultChecked className="rounded border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer" id="enableAiAssist" />
                                                <label htmlFor="enableAiAssist" className="text-[10px] text-slate-650 font-bold cursor-pointer">Enable AI Meeting Assistant (Captions, transcript sync & summarization)</label>
                                            </div>
                                        </div>
                                    )}

                                    {/* Recurrence Setup */}

                                    <div className="flex items-start gap-4">
                                        <svg className="w-5 h-5 text-slate-400 mt-2.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 1121.21 7.89M9 11l3 3L22 4" /></svg>
                                        <div className="flex-grow">
                                            <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Meeting Recurrence</label>
                                            <select
                                                value={scheduleRecurring}

                                                onChange={(e) => setScheduleRecurring(e.target.value)}

                                                className="bg-white border border-slate-200 rounded-lg px-3 py-2 outline-none text-slate-700 text-xs w-full focus:border-blue-500 cursor-pointer shadow-sm hover:border-slate-350 transition-colors"
                                            >
                                                <option value="none">Does not repeat</option>
                                                <option value="daily">Daily recurrence</option>
                                                <option value="weekly">Weekly recurrence</option>
                                                <option value="monthly">Monthly recurrence</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* Workspace Selection */}

                                    <div className="flex items-start gap-4">
                                        <svg className="w-5 h-5 text-slate-400 mt-2.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5" /></svg>
                                        <div className="flex-grow">
                                            <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Workspace / Meeting Space</label>
                                            <select
                                                value={scheduleSpaceId}

                                                onChange={(e) => setScheduleSpaceId(e.target.value)}

                                                className="bg-white border border-slate-200 rounded-lg px-3 py-2 outline-none text-slate-700 text-xs w-full focus:border-blue-500 cursor-pointer shadow-sm hover:border-slate-350 transition-colors"
                                            >
                                                {spaces.map(space => (
                                                    <option key={space.id} value={space.id}>{space.name}</option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                    {/* Location Input */}

                                    <div className="flex items-center gap-4">
                                        <svg className="w-5 h-5 text-slate-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                        <input
                                            type="text"
                                            placeholder="Add location (e.g. Virtual or specific address)"
                                            value={scheduleLocation}

                                            onChange={(e) => setScheduleLocation(e.target.value)}

                                            className="bg-transparent border-b border-slate-200 focus:border-blue-500 w-full pb-1 outline-none text-xs text-slate-700 placeholder-slate-400 hover:border-slate-300 transition-colors"
                                        />
                                    </div>
                                    {/* Notification Input */}

                                    <div className="flex items-center gap-4">
                                        <svg className="w-5 h-5 text-slate-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>
                                        <div className="flex items-center gap-2 text-xs text-slate-650">
                                            <span>Notification</span>
                                            <input
                                                type="number"
                                                value={scheduleNotification}

                                                onChange={(e) => setScheduleNotification(e.target.value)}

                                                className="bg-white border border-slate-200 rounded-lg px-2 py-1 w-16 text-center text-slate-700 outline-none focus:border-blue-500 text-xs shadow-sm hover:border-slate-350 transition-colors"
                                            />
                                            <span>minutes</span>
                                        </div>
                                    </div>
                                    {/* Calendar Creator displaying Owner */}

                                    <div className="flex items-center gap-4 text-xs text-slate-650">
                                        <div className="w-5 h-5 rounded-full bg-blue-500 flex-shrink-0 flex items-center justify-center font-bold text-white text-[10px]">
                                            {user?.first_name ? user.first_name[0].toUpperCase() : 'S'}

                                        </div>
                                        <span>{user?.first_name ? `${user.first_name} ${user.last_name || ''}` : 'sowndar moorthy'}</span>
                                    </div>
                                    {/* Busy & Visibility Dropdowns */}

                                    <div className="flex items-center gap-4">
                                        <svg className="w-5 h-5 text-slate-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                                        <div className="flex items-center gap-3 text-xs">
                                            <select
                                                value={scheduleBusy ? "busy" : "free"}

                                                onChange={(e) => setScheduleBusy(e.target.value === "busy")}

                                                className="bg-white border border-slate-200 rounded-lg px-3 py-2 text-xs text-slate-700 outline-none focus:border-blue-500 cursor-pointer shadow-sm hover:border-slate-350 transition-colors"
                                            >
                                                <option value="busy">Busy</option>
                                                <option value="free">Free</option>
                                            </select>
                                            <select
                                                value={scheduleVisibility}

                                                onChange={(e) => setScheduleVisibility(e.target.value)}

                                                className="bg-white border border-slate-200 rounded-lg px-3 py-2 text-xs text-slate-700 outline-none focus:border-blue-500 cursor-pointer shadow-sm hover:border-slate-350 transition-colors"
                                            >
                                                <option value="default">Default visibility</option>
                                                <option value="public">Public</option>
                                                <option value="private">Private</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* Description Textarea */}

                                    <div className="flex items-start gap-4">
                                        <svg className="w-5 h-5 text-slate-400 mt-2 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h7" /></svg>
                                        <div className="flex-grow space-y-0.5">
                                            <div className="flex items-center gap-3 bg-slate-50 px-3 py-1.5 rounded-t-lg border border-slate-200 border-b-0 text-slate-500 text-xs">
                                                <span className="font-bold cursor-pointer hover:text-slate-700">B</span>
                                                <span className="italic cursor-pointer hover:text-slate-700">I</span>
                                                <span className="underline cursor-pointer hover:text-slate-700">U</span>
                                                <span className="cursor-pointer hover:text-slate-700 ml-2 text-sm leading-none">≡</span>
                                            </div>
                                            <textarea
                                                placeholder="Add description"
                                                value={scheduleDescription}

                                                onChange={(e) => setScheduleDescription(e.target.value)}

                                                className="bg-white border border-slate-200 rounded-b-lg p-3 outline-none text-xs text-slate-700 w-full h-24 focus:border-blue-500 placeholder-slate-400 resize-none shadow-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Right Column (Guests Sidebar) */}
                            <div className="lg:border-l lg:border-slate-200 lg:pl-6 text-xs">
                                <div className="space-y-6">
                                    {/* Meeting Visibility & Attendees Options */}

                                    <div className="space-y-4 bg-slate-50 p-4 rounded-xl border border-slate-200 text-[11px]">
                                        <label className="block font-bold text-slate-500 uppercase tracking-wider mb-1 text-[10px]">
                                            Visibility & Attendance
                                        </label>
                                        <div className="space-y-3">
                                            {/* Option 1: All Employees */}

                                            <label className="flex items-start gap-2.5 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    name="targetType"
                                                    value="all_employees"
                                                    checked={targetType.includes('all_employees')}

                                                    onChange={(e) => {
                                                        if (e.target.checked) setTargetType(prev => [...prev, 'all_employees']);
                                                        else setTargetType(prev => prev.filter(v => v !== 'all_employees'));
                                                    }}

                                                    className="mt-0.5 rounded border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer"
                                                />
                                                <div className="-mt-0.5">
                                                    <span className="font-semibold text-slate-750">Internal Employees (All)</span>
                                                    <p className="text-[10px] text-slate-400">Visible to all employees on their HRMS dashboard & calendar.</p>
                                                </div>
                                            </label>
                                            {/* Option 2: Selective Employees */}

                                            <label className="flex items-start gap-2.5 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    name="targetType"
                                                    value="selective_employees"
                                                    checked={targetType.includes('selective_employees')}

                                                    onChange={(e) => {
                                                        if (e.target.checked) setTargetType(prev => [...prev, 'selective_employees']);
                                                        else setTargetType(prev => prev.filter(v => v !== 'selective_employees'));
                                                    }}

                                                    className="mt-0.5 rounded border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer"
                                                />
                                                <div className="-mt-0.5">
                                                    <span className="font-semibold text-slate-750">Internal Employees (Selective)</span>
                                                    <p className="text-[10px] text-slate-400">Only visible to chosen employees on their calendar & dashboard.</p>
                                                </div>
                                            </label>
                                            {/* Employee Selection Dropdown / Checkbox List */}

                                            {targetType.includes('selective_employees') && (
                                                <div className="pl-6 mt-1 space-y-1.5 animate-fadeIn">
                                                    <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Select Employees</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Search employees..."
                                                        value={employeeSearchQuery}
                                                        onChange={(e) => setEmployeeSearchQuery(e.target.value)}
                                                        className={`w-full bg-white border ${scheduleFormErrors.selective_employees ? 'border-red-500' : 'border-slate-200'} rounded-lg px-2.5 py-1.5 text-xs text-slate-700 focus:border-blue-500 outline-none placeholder-slate-400 shadow-sm`}
                                                    />
                                                    <div className="bg-white rounded-lg border border-slate-200 max-h-40 overflow-y-auto custom-scrollbar shadow-inner flex flex-col mt-1">
                                                        {(() => {
                                                            const filteredEmployeesForSelection = allEmployeesList.filter(emp =>
                                                                emp.name.toLowerCase().includes(employeeSearchQuery.toLowerCase()) ||
                                                                (emp.email && emp.email.toLowerCase().includes(employeeSearchQuery.toLowerCase()))
                                                            );
                                                            
                                                            return (
                                                                <>
                                                                    {allEmployeesList.length > 0 && (
                                                                        <div className="flex justify-end sticky top-0 bg-white z-10 pt-2 pb-1 px-2 border-b border-slate-100">
                                                                            <label className="flex items-center gap-2 cursor-pointer hover:bg-slate-50 rounded px-1 py-0.5">
                                                                                <span className="text-slate-700 text-[10px] font-bold uppercase tracking-wider">Select All</span>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={filteredEmployeesForSelection.length > 0 && filteredEmployeesForSelection.every(emp => selectedEmployees.includes(emp.user_id))}
                                                                                    onChange={(e) => {
                                                                                        if (e.target.checked) {
                                                                                            const newSelected = [...selectedEmployees];
                                                                                            filteredEmployeesForSelection.forEach(emp => {
                                                                                                if (!newSelected.includes(emp.user_id)) newSelected.push(emp.user_id);
                                                                                            });
                                                                                            setSelectedEmployees(newSelected);
                                                                                        } else {
                                                                                            const filteredIds = filteredEmployeesForSelection.map(emp => emp.user_id);
                                                                                            setSelectedEmployees(prev => prev.filter(id => !filteredIds.includes(id)));
                                                                                        }
                                                                                    }}
                                                                                    className="rounded-sm border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer"
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <div className="px-2 pb-2 pt-1 space-y-1">
                                                                        {allEmployeesList.length === 0 ? (
                                                                            <span className="text-[10px] text-slate-500">Loading employees...</span>
                                                                        ) : filteredEmployeesForSelection.length === 0 ? (
                                                                            <span className="text-[10px] text-slate-400 block p-1">No employees found</span>
                                                                        ) : (
                                                                            filteredEmployeesForSelection.map(emp => (
                                                                                <label key={emp.user_id} className="flex items-center justify-between cursor-pointer py-0.5 hover:bg-slate-50 rounded px-1">
                                                                                    <span className="text-slate-650 text-[11px]">{emp.name}</span>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={selectedEmployees.includes(emp.user_id)}
                                                                                        onChange={(e) => {
                                                                                            if (e.target.checked) {
                                                                                                setSelectedEmployees(prev => [...prev, emp.user_id]);
                                                                                            } else {
                                                                                                setSelectedEmployees(prev => prev.filter(id => id !== emp.user_id));
                                                                                            }
                                                                                        }}
                                                                                        className="rounded-sm border-slate-350 bg-white text-blue-500 focus:ring-0 w-3 h-3 cursor-pointer"
                                                                                    />
                                                                                </label>
                                                                            ))
                                                                        )}
                                                                    </div>
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                    {scheduleFormErrors.selective_employees && (
                                                        <p className="text-[10px] text-red-500 font-bold mt-1">
                                                            {scheduleFormErrors.selective_employees}

                                                        </p>
                                                    )}

                                                </div>
                                            )}

                                            {/* Option 3: Customers */}

                                            <label className="flex items-start gap-2.5 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    name="targetType"
                                                    value="customers"
                                                    checked={targetType.includes('customers')}

                                                    onChange={(e) => {
                                                        if (e.target.checked) setTargetType(prev => [...prev, 'customers']);
                                                        else setTargetType(prev => prev.filter(v => v !== 'customers'));
                                                    }}

                                                    className="mt-0.5 rounded border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer"
                                                />
                                                <div className="-mt-0.5">
                                                    <span className="font-semibold text-slate-750">Customers (Shareable Link)</span>
                                                    <p className="text-[10px] text-slate-400">Generate an open link for customers to join.</p>
                                                </div>
                                            </label>
                                            {/* Customer Informational Alert */}

                                            {targetType.includes('customers') && (
                                                <div className="pl-6 mt-1 animate-fadeIn">
                                                    <div className="bg-blue-50 border border-blue-100 rounded-lg p-2.5 flex items-start gap-2">
                                                        <svg className="w-4 h-4 text-blue-500 mt-0.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" /></svg>
                                                        <p className="text-[10px] text-blue-700 leading-relaxed font-medium">
                                                            A shareable link will be provided after creating the meeting.
                                                        </p>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Option 4: Manually Add Emails */}

                                            <label className="flex items-start gap-2.5 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    name="targetType"
                                                    value="manual_emails"
                                                    checked={targetType.includes('manual_emails')}

                                                    onChange={(e) => {
                                                        if (e.target.checked) setTargetType(prev => [...prev, 'manual_emails']);
                                                        else setTargetType(prev => prev.filter(v => v !== 'manual_emails'));
                                                    }}

                                                    className="mt-0.5 rounded border-slate-350 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer"
                                                />
                                                <div className="-mt-0.5">
                                                    <span className="font-semibold text-slate-750">Manually Add Guest Emails</span>
                                                    <p className="text-[10px] text-slate-400">Send direct email invitations to external or manual guests.</p>
                                                </div>
                                            </label>
                                            {targetType.includes('manual_emails') && (
                                                <div className="pl-6 mt-1 animate-fadeIn">
                                                    <label className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider mb-1">Guest Emails (Comma separated)</label>
                                                    <textarea
                                                        placeholder="john@example.com, alice@example.com"
                                                        value={manualEmails}

                                                        onChange={(e) => setManualEmails(e.target.value)}

                                                        className="bg-white border border-slate-200 rounded-lg p-2 outline-none text-slate-700 text-[11px] w-full h-16 focus:border-blue-500 placeholder-slate-400 resize-none shadow-sm"
                                                    />
                                                    {scheduleFormErrors.manual_emails && (
                                                        <p className="text-[10px] text-red-500 font-bold mt-1">
                                                            {scheduleFormErrors.manual_emails}

                                                        </p>
                                                    )}

                                                </div>
                                            )}

                                        </div>
                                    </div>
                                    <div>
                                        <label className="block font-bold text-slate-500 uppercase tracking-wider mb-2">Guests</label>
                                        <input
                                            type="text"
                                            placeholder="Add guests"
                                            value={scheduleGuests}

                                            onChange={(e) => setScheduleGuests(e.target.value)}

                                            className="bg-white border border-slate-200 rounded-lg px-3 py-2 outline-none text-slate-700 text-xs w-full focus:border-blue-500 placeholder-slate-400 shadow-sm hover:border-slate-300 transition-colors"
                                        />
                                    </div>
                                    <div className="space-y-3">
                                        <label className="block font-bold text-slate-500 uppercase tracking-wider">Guest permissions</label>
                                        <div className="space-y-2 text-slate-600">
                                            <label className="flex items-center gap-2.5 cursor-pointer">
                                                <input type="checkbox" className="rounded border-slate-300 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer" />
                                                <span>Modify event</span>
                                            </label>
                                            <label className="flex items-center gap-2.5 cursor-pointer">
                                                <input type="checkbox" defaultChecked className="rounded border-slate-300 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer" />
                                                <span>Invite others</span>
                                            </label>
                                            <label className="flex items-center gap-2.5 cursor-pointer">
                                                <input type="checkbox" defaultChecked className="rounded border-slate-300 bg-white text-blue-500 focus:ring-0 w-3.5 h-3.5 cursor-pointer" />
                                                <span>See guest list</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            
                            {/* Action Buttons (Fixed Bottom) */}
                            <div className="px-6 py-4 flex justify-end items-center gap-3 bg-white shrink-0">
                                <button
                                    type="button"
                                    onClick={() => setShowScheduleFormModal(false)}
                                    className="px-5 py-2 rounded-full text-xs font-bold text-slate-600 bg-white border border-slate-300 hover:bg-slate-50 transition-colors shadow-sm"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="bg-main hover:bg-mainHover text-white font-extrabold px-6 py-2 rounded-full text-xs shadow-md transition-all"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Modal for Calendar scheduling success */}

            {showCalendarModal && (
                <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
                    <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl border border-slate-200 text-center space-y-4">
                        <div className="flex justify-center">
                            <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600">
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>
                            </div>
                        </div>
                        <h3 className="text-base font-extrabold text-slate-900">Meeting Scheduled</h3>
                        <p className="text-xs text-slate-500 leading-relaxed">
                            This meeting has been scheduled in your workspace collaboration calendar.
                        </p>
                        <button
                            onClick={() => setShowCalendarModal(false)}

                            className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold w-full py-2.5 rounded-xl transition-all text-xs text-center shadow-md shadow-emerald-600/15"
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}

            {/* Custom Resolution Notes Popup */}
            {resolutionPopup.show && (
                <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-fadeIn">
                    <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl border border-slate-200 text-left space-y-4">
                        <div className="flex items-center gap-3 text-slate-800">
                            <svg className="w-6 h-6 text-main flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01m-.01 4h.01" /></svg>
                            <h3 className="text-base font-extrabold text-slate-950 font-sans">Resolve Escalation</h3>
                        </div>
                        <div className="space-y-2">
                            <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Resolution Notes *</label>
                            <textarea
                                value={resolutionPopup.notes}
                                onChange={(e) => setResolutionPopup(prev => ({ ...prev, notes: e.target.value }))}
                                placeholder="Enter details on how the schedule capacity or conflict was resolved..."
                                className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-xs outline-none focus:border-main focus:bg-white text-slate-700 min-h-[90px] resize-none transition-all"
                            />
                        </div>
                        <div className="flex gap-3 pt-2">
                            <button
                                onClick={() => setResolutionPopup({ show: false, escalationId: null, notes: '' })}
                                className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center border border-slate-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={submitEscalationResolution}
                                className="bg-main hover:bg-mainHover text-white font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center shadow-md shadow-main/15"
                            >
                                Resolve
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Meeting Modal */}
            {editMeetingModal.show && (
                <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-fadeIn">
                    <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl border border-slate-200 text-left space-y-4">
                        <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                            <h3 className="text-sm font-extrabold text-slate-950 font-sans">Edit Meeting Schedule</h3>
                            <button 
                                onClick={() => setEditMeetingModal({ show: false, meetingId: null, title: '', date: '', startTime: '', endTime: '', errors: {} })}
                                className="text-slate-400 hover:text-slate-600 p-1 hover:bg-slate-100 rounded-full transition-colors"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>

                        <div className="space-y-4">
                            <div className="space-y-1">
                                <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Title *</label>
                                <input
                                    type="text"
                                    value={editMeetingModal.title}
                                    onChange={(e) => setEditMeetingModal(prev => ({ ...prev, title: e.target.value }))}
                                    className={`w-full bg-slate-50 border ${editMeetingModal.errors.title ? 'border-red-500' : 'border-slate-200'} rounded-xl px-3 py-2 text-xs outline-none focus:border-main focus:bg-white text-slate-700 transition-all`}
                                />
                                {editMeetingModal.errors.title && (
                                    <p className="text-[9px] text-red-500 font-semibold mt-0.5">{editMeetingModal.errors.title}</p>
                                )}
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                <div className="space-y-1">
                                    <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Date *</label>
                                    <input
                                        type="date"
                                        value={editMeetingModal.date}
                                        onChange={(e) => setEditMeetingModal(prev => ({ ...prev, date: e.target.value }))}
                                        className={`w-full bg-slate-50 border ${editMeetingModal.errors.date ? 'border-red-500' : 'border-slate-200'} rounded-xl px-3 py-2 text-xs outline-none focus:border-main focus:bg-white text-slate-700 transition-all`}
                                    />
                                    {editMeetingModal.errors.date && (
                                        <p className="text-[9px] text-red-500 font-semibold mt-0.5">{editMeetingModal.errors.date}</p>
                                    )}
                                </div>

                                <div className="space-y-1">
                                    <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Start Time *</label>
                                    <input
                                        type="time"
                                        value={editMeetingModal.startTime}
                                        onChange={(e) => setEditMeetingModal(prev => ({ ...prev, startTime: e.target.value }))}
                                        className={`w-full bg-slate-50 border ${editMeetingModal.errors.startTime ? 'border-red-500' : 'border-slate-200'} rounded-xl px-3 py-2 text-xs outline-none focus:border-main focus:bg-white text-slate-700 transition-all`}
                                    />
                                    {editMeetingModal.errors.startTime && (
                                        <p className="text-[9px] text-red-500 font-semibold mt-0.5">{editMeetingModal.errors.startTime}</p>
                                    )}
                                </div>

                                <div className="space-y-1">
                                    <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">End Time</label>
                                    <input
                                        type="time"
                                        value={editMeetingModal.endTime}
                                        onChange={(e) => setEditMeetingModal(prev => ({ ...prev, endTime: e.target.value }))}
                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-xs outline-none focus:border-main focus:bg-white text-slate-700 transition-all"
                                    />
                                </div>
                            </div>

                            {editMeetingModal.errors.time && (
                                <p className="text-[9px] text-red-500 font-semibold text-center mt-1">{editMeetingModal.errors.time}</p>
                            )}
                        </div>

                        <div className="flex gap-3 pt-3 border-t border-slate-100">
                            <button
                                onClick={() => setEditMeetingModal({ show: false, meetingId: null, title: '', date: '', startTime: '', endTime: '', errors: {} })}
                                className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center border border-slate-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={submitEditMeeting}
                                className="bg-main hover:bg-mainHover text-white font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center shadow-md shadow-main/15"
                            >
                                Update Schedule
                            </button>
                        </div>
                    </div>
                </div>
            )}

             {/* Custom Alert Popup */}

            {alertPopup.show && (
                <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-fadeIn">
                    <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl border border-slate-200 text-left space-y-4">
                        <div className={`flex items-center gap-3 ${
                            (alertPopup.title?.toLowerCase().includes('copied') || alertPopup.title?.toLowerCase().includes('success'))
                                ? 'text-emerald-650'
                                : 'text-red-505'
                        }`}>
                            {(alertPopup.title?.toLowerCase().includes('copied') || alertPopup.title?.toLowerCase().includes('success')) ? (
                                <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            )}
                            <h3 className="text-base font-extrabold text-slate-950">{alertPopup.title}</h3>
                        </div>
                        <p className="text-xs text-slate-600 leading-relaxed font-semibold">
                            {alertPopup.message}

                        </p>
                        <button
                            onClick={() => setAlertPopup({ show: false, message: '', title: 'Notification' })}

                            className="bg-main hover:bg-mainHover text-white font-bold w-full py-2.5 rounded-xl transition-all text-xs text-center shadow-md shadow-main/15"
                        >
                            Okay
                        </button>
                    </div>
                </div>
            )}

            {/* Custom Confirm Popup */}

            {confirmPopup.show && (
                <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-fadeIn">
                    <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl border border-slate-200 text-left space-y-4">
                        <div className="flex items-center gap-3 text-slate-800">
                            <svg className="w-6 h-6 text-yellow-505 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                            <h3 className="text-base font-extrabold text-slate-950 font-sans">{confirmPopup.title || 'Confirm'}</h3>
                        </div>
                        <p className="text-xs text-slate-600 leading-relaxed font-semibold">
                            {confirmPopup.message}

                        </p>
                        <div className="flex gap-3 pt-2">
                            <button
                                onClick={() => setConfirmPopup({ show: false, message: '', title: '', onConfirm: null })}

                                className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center border border-slate-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    if (confirmPopup.onConfirm) confirmPopup.onConfirm();
                                    setConfirmPopup({ show: false, message: '', title: '', onConfirm: null });
                                }}

                                className="bg-red-500 hover:bg-red-600 text-white font-bold flex-1 py-2.5 rounded-xl transition-all text-xs text-center shadow-md shadow-red-500/15"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Provider Admin Modal */}

            {showProviderAdmin && (
                <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[110] p-4 animate-fadeIn">
                    <div className="bg-white rounded-[2rem] w-full max-w-5xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
                        {/* Header */}

                        <div className="bg-main px-8 py-5 flex items-center justify-between shrink-0">
                            <div className="flex items-center gap-3">
                                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                </span>
                                <div>
                                    <h2 className="text-lg font-black text-white">Meeting Provider Accounts</h2>
                                    <p className="text-[10px] text-red-100/80 font-semibold uppercase tracking-wider">Configure Zoom and Google Meet automated scheduling limits</p>
                                </div>
                            </div>
                            <button onClick={() => setShowProviderAdmin(false)} className="text-red-200 hover:text-white transition-colors bg-black/10 hover:bg-black/20 rounded-full p-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <div className="flex-grow overflow-y-auto p-8 bg-white space-y-8">
                            {showProviderForm ? (
                                <div className="space-y-5 animate-fadeIn">
                                    <div className="flex justify-between items-center pb-4 border-b border-slate-100">
                                        <h3 className="text-sm font-black text-slate-800 uppercase tracking-wider">
                                            {editingProviderId ? 'Edit Provider Account' : 'Add Provider Account'}

                                        </h3>
                                        <button
                                            onClick={() => setShowProviderForm(false)}

                                            className="text-slate-500 hover:text-slate-800 transition-colors flex items-center gap-1 text-xs font-bold"
                                        >
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                            Back to Accounts
                                        </button>
                                    </div>
                                    <div className="space-y-5">
                                        <div className="grid grid-cols-2 gap-5">
                                            <div>
                                                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Provider Type</label>
                                                <select
                                                    value={providerFormData.provider}

                                                    onChange={(e) => setProviderFormData({...providerFormData, provider: e.target.value})}

                                                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-semibold focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                >
                                                    <option value="zoom">Zoom</option>
                                                    <option value="google_meet">Google Meet</option>
                                                </select>
                                            </div>
                                            <div>
                                                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Account Label</label>
                                                <input
                                                    type="text"
                                                    placeholder="e.g. Sales Team Zoom"
                                                    value={providerFormData.account_label}

                                                    onChange={(e) => setProviderFormData({...providerFormData, account_label: e.target.value})}

                                                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-semibold focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Account Email</label>
                                                <input
                                                    type="email"
                                                    placeholder="admin@company.com"
                                                    value={providerFormData.email}

                                                    onChange={(e) => setProviderFormData({...providerFormData, email: e.target.value})}

                                                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-semibold focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Max Concurrent Meetings</label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    value={providerFormData.max_concurrent}

                                                    onChange={(e) => setProviderFormData({...providerFormData, max_concurrent: parseInt(e.target.value) || 1})}

                                                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-semibold focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                />
                                            </div>
                                        </div>
                                        <div className="pt-5 mt-5 border-t border-slate-100">
                                            <h4 className="text-[10px] font-black text-slate-600 uppercase tracking-wider mb-4">API Credentials</h4>
                                            <div className="space-y-4">
                                                <div>
                                                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Client ID (OAuth)</label>
                                                    <input
                                                        type="text"
                                                        value={providerFormData.client_id || ''}

                                                        onChange={(e) => setProviderFormData({...providerFormData, client_id: e.target.value})}

                                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-mono focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Client Secret (OAuth)</label>
                                                    <input
                                                        type="password"
                                                        value={providerFormData.client_secret || ''}

                                                        onChange={(e) => setProviderFormData({...providerFormData, client_secret: e.target.value})}

                                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-mono focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Account / App ID (Zoom Account ID or GCalendar ID)</label>
                                                    <input
                                                        type="text"
                                                        value={providerFormData.account_id || ''}

                                                        onChange={(e) => setProviderFormData({...providerFormData, account_id: e.target.value})}

                                                        className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-mono focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                    />
                                                </div>
                                                {providerFormData.provider === 'google_meet' && (
                                                    <div>
                                                        <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1.5">Refresh Token (Google OAuth)</label>
                                                        <input
                                                            type="text"
                                                            value={providerFormData.refresh_token || ''}

                                                            onChange={(e) => setProviderFormData({...providerFormData, refresh_token: e.target.value})}

                                                            className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-xs text-slate-700 font-mono focus:border-main focus:ring-1 focus:ring-main outline-none transition-all"
                                                        />
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                        <div className="pt-6 mt-6 border-t border-slate-100 flex justify-end gap-3">
                                            <button
                                                onClick={() => setShowProviderForm(false)}

                                                className="px-6 py-2.5 text-xs font-bold text-slate-600 hover:text-slate-800 transition-colors"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={handleSaveProviderAccount}

                                                className="bg-main hover:bg-mainHover text-white font-bold px-6 py-2.5 rounded-xl transition-colors text-xs shadow-md shadow-main/20"
                                            >
                                                {editingProviderId ? 'Update Account' : 'Save Account'}

                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {/* Escalations Section */}

                                    {escalations.length > 0 && (
                                        <section>
                                            <div className="flex items-center gap-2 mb-4">
                                                <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                                                <h3 className="text-sm font-black text-slate-800 uppercase tracking-wider">Active Escalations ({escalations.length})</h3>
                                            </div>
                                            <div className="space-y-3">
                                                {escalations.map(esc => (
                                                    <div key={esc.id} className="bg-red-50 border border-red-100 rounded-xl p-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
                                                        <div>
                                                            <div className="flex items-center gap-2 mb-1">
                                                                <span className="bg-red-500 text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase">{esc.provider}</span>
                                                                <span className="text-[10px] text-red-700 font-semibold">{new Date(esc.created_at).toLocaleString()} by {esc.requested_by_name || esc.requested_by}</span>
                                                            </div>
                                                            <p className="text-xs text-red-900 font-medium">{esc.message}</p>
                                                        </div>
                                                        <button
                                                            onClick={() => handleResolveEscalation(esc.id)}

                                                            className="shrink-0 bg-red-100 hover:bg-red-200 text-red-700 text-xs font-bold px-4 py-2 rounded-lg transition-colors border border-red-200"
                                                        >
                                                            Mark Resolved
                                                        </button>
                                                    </div>
                                                ))}

                                            </div>
                                        </section>
                                    )}

                                    {/* Accounts Section */}

                                    <section>
                                        <div className="flex items-center justify-between mb-4">
                                            <h3 className="text-sm font-black text-slate-800 uppercase tracking-wider">Configured Accounts</h3>
                                            <button
                                                onClick={() => {
                                                    setProviderFormData({
                                                        provider: 'zoom', account_label: '', email: '', client_id: '', client_secret: '',
                                                        account_id: '', api_key: '', api_secret: '', refresh_token: '',
                                                        max_concurrent: 1, subscription_tier: 'pro', notes: ''
                                                    });
                                                    setEditingProviderId(null);
                                                    setShowProviderForm(true);
                                                }}

                                                className="bg-main hover:bg-mainHover text-white text-[10px] font-bold uppercase tracking-wider px-4 py-2.5 rounded-xl flex items-center gap-2 shadow-sm transition-all"
                                            >
                                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg>
                                                Add Account
                                            </button>
                                        </div>
                                        {providerAccounts.length === 0 ? (
                                            <div className="text-center py-12 bg-white border border-slate-200 border-dashed rounded-2xl">
                                                <p className="text-sm font-bold text-slate-600 mb-2">No provider accounts configured</p>
                                                <p className="text-[11px] text-slate-400 max-w-md mx-auto">Add a Zoom or Google Meet API account to enable automatic meeting scheduling. Collab will load-balance across available accounts automatically.</p>
                                            </div>
                                        ) : (
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {providerAccounts.map(acc => (
                                                    <div key={acc.id} className="bg-white border border-slate-200 p-5 rounded-2xl shadow-sm relative overflow-hidden group">
                                                        {/* Provider icon watermark */}

                                                        <div className="absolute -right-4 -bottom-4 opacity-[0.03] pointer-events-none">
                                                            {acc.provider === 'zoom' ? (
                                                                <svg className="w-32 h-32" fill="currentColor" viewBox="0 0 24 24"><path d="M4.585 13.607l-.27-.012H1.886l3.236-3.137L1.886 7.32l2.429-.012 2.226 2.144L8.767 7.32l2.43.012-3.236 3.138 3.236 3.137-2.43-.012-2.226-2.144-2.226 2.144h.27zM22.114 7.32l-2.43.012 3.236 3.138-3.236 3.137 2.43-.012 2.226-2.144L22.114 7.32zM15.42 15.353a4.015 4.015 0 01-3.42-1.928 4.015 4.015 0 01-3.42 1.928A4.04 4.04 0 014.54 11.31a4.04 4.04 0 014.04-4.042 4.015 4.015 0 013.42 1.928 4.015 4.015 0 013.42-1.928 4.04 4.04 0 014.04 4.042 4.04 4.04 0 01-4.04 4.043z"/></svg>
                                                            ) : (
                                                                <svg className="w-32 h-32" fill="currentColor" viewBox="0 0 24 24"><path d="M21.196 4.954l-2.29-2.29a1.002 1.002 0 00-1.414 0l-1.393 1.393-5.26-5.26c-.39-.39-1.024-.39-1.414 0L1.758 6.464a1.002 1.002 0 000 1.414l5.26 5.26c.39.39 1.024.39 1.414 0l1.393-1.393 2.29 2.29c.39.39.39 1.024 0 1.414L3.81 23.754A1.002 1.002 0 003.81 25.17l2.29 2.29c.39.39 1.024.39 1.414 0l8.305-8.305c.39-.39.39-1.024 0-1.414l-2.29-2.29 1.393-1.393 5.26 5.26c.39.39 1.024.39 1.414 0l7.667-7.667a1.002 1.002 0 000-1.414z"/></svg>
                                                            )}

                                                        </div>
                                                        <div className="flex justify-between items-start mb-3">
                                                            <div>
                                                                <div className="flex items-center gap-2 mb-1">
                                                                    <span className={`text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded ${acc.provider === 'zoom' ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'}`}>
                                                                        {acc.provider.replace('_', ' ')}

                                                                    </span>
                                                                    <span className={`flex items-center gap-1 text-[9px] font-bold ${acc.status === 'active' ? 'text-emerald-500' : 'text-red-500'}`}>
                                                                        <span className={`w-1.5 h-1.5 rounded-full ${acc.status === 'active' ? 'bg-emerald-500' : 'bg-red-500'}`}></span>
                                                                        {acc.status}

                                                                    </span>
                                                                </div>
                                                                <h4 className="text-sm font-bold text-slate-800">{acc.account_label}</h4>
                                                            </div>
                                                            <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                                                                <button
                                                                    onClick={async () => {
                                                                        const res = await api.get(`/collab-meetings/provider-accounts/${acc.id}`);
                                                                        setProviderFormData(res.data.data);
                                                                        setEditingProviderId(acc.id);
                                                                        setShowProviderForm(true);
                                                                    }}

                                                                    className="p-1.5 text-slate-400 hover:text-blue-500 bg-slate-50 hover:bg-blue-50 rounded"
                                                                >
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
                                                                </button>
                                                                <button
                                                                    onClick={() => handleDeleteProviderAccount(acc.id)}

                                                                    className="p-1.5 text-slate-400 hover:text-red-500 bg-slate-50 hover:bg-red-50 rounded"
                                                                >
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="space-y-1.5 text-[11px] text-slate-500 font-medium relative z-10">
                                                            <p className="flex items-center gap-2"><svg className="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg> {acc.email || 'No email'}</p>
                                                            <p className="flex items-center gap-2"><svg className="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg> {acc.max_concurrent} concurrent meeting(s)</p>
                                                            <p className="flex items-center gap-2"><svg className="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /></svg> {acc.subscription_tier} tier</p>
                                                        </div>
                                                        <div className="mt-4 pt-3 border-t border-slate-100 flex justify-between items-center relative z-10">
                                                            <span className="text-[9px] text-slate-400">Last used: {acc.last_used_at ? new Date(acc.last_used_at).toLocaleDateString() : 'Never'}</span>
                                                            <button
                                                                onClick={() => handleTestProviderAccount(acc.id)}

                                                                className="text-[10px] font-bold text-main hover:text-mainHover"
                                                            >
                                                                Test Connection
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        )}

                                    </section>
                                </>
                            )}

                            {/* Test Result Toast */}

                            {providerTestResult && (
                                <div className="fixed bottom-6 right-6 bg-white p-4 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.15)] border border-slate-200 flex items-start gap-3 z-[130] animate-fadeIn max-w-sm">
                                    <span className={`flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full ${providerTestResult.valid ? 'bg-emerald-100 text-emerald-600' : 'bg-red-100 text-red-600'}`}>
                                        {providerTestResult.valid ? (
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                                        ) : (
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                                        )}

                                    </span>
                                    <div>
                                        <h4 className={`text-xs font-black ${providerTestResult.valid ? 'text-emerald-700' : 'text-red-700'}`}>
                                            {providerTestResult.valid ? 'Connection Successful' : 'Connection Failed'}

                                        </h4>
                                        <p className="text-[10px] text-slate-600 font-medium mt-0.5">{providerTestResult.message}</p>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            )}

            </div>
        </Layout>
    );
};
export default CollabMeetingDashboard;